// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:39:32.955Z
// Property: Element at Stonebridge (ID: 5695348706115584)
// Collections: 30 amenities, 8 floorplans (live), 22 photos, 83 POIs, 4 reviews, 5 virtual tours, 6 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5695348706115584",
  "property_external_id": "5005818",
  "property_zillow_url": "https://www.zillow.com/apartments/north-chesterfield-va/element-at-stonebridge-brand-new-luxury-apartments/65cxCD/",
  "property_apartments_url": "https://www.apartments.com/element-at-stonebridge-north-chesterfield-va/byw4yj9",
  "property_google_business_url": "https://www.google.com/maps?q=element+at+stonebridge&um=1&ie=UTF-8&sa=X&ved=2ahUKEwiT5eSwvKj5AhWckWoFHfJXBR8Q_AUoAXoECAIQAw",
  "property_linkedin_url": null,
  "property_hubspot_id": "9282123606",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "element-at-stonebridge",
  "property_name": "Element at Stonebridge",
  "property_website_url": "https://www.elementatstonebridge.com/",
  "property_domain": "https://www.elementatstonebridge.com/",
  "property_address": "301 Karl Linn Dr",
  "property_full_address": "301 Karl Linn Dr, Richmond, VA 23225",
  "property_address_1": "301 Karl Linn Dr",
  "property_address_2": null,
  "property_address_city": "Richmond",
  "property_address_state": "VA",
  "property_address_zip_full": "23225-6973",
  "property_address_zip": "23225",
  "property_address_country": "US",
  "property_address_county": "Chesterfield County",
  "property_neighborhood_address": "Chesterfield County",
  "property_address_latitude": "37.4970063",
  "property_address_longitude": "-77.52751649999999",
  "property_email": "element@alapts.com",
  "property_phone": "(804) 571-2787",
  "property_call_tracking_phone": "804-534-1187",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Stonebridge apartments with everyday convenience built in.</strong> Explore one- and two-bedroom homes with polished finishes, smart in-home features, and connected courtyard-style amenities—then schedule your tour of Element at Stonebridge today.</p>",
  "property_long_description": "<p><strong>Modern North Chesterfield apartments in the heart of Stonebridge.</strong> At Element at Stonebridge, you’re surrounded by everyday convenience—Kroger Marketplace, dining, services, and retail at Stonebridge Shopping Center—while Chippenham Parkway, the GRTC bus line, Chippenham Hospital, downtown Richmond, and the West End are all easy to reach.</p><p>Choose a one- or two-bedroom <a href=\"/floor-plans\">floor plan</a> with polished finishes like granite countertops, stainless steel appliances, a full-size washer and dryer, smart thermostats, USB outlets, large windows, and available walk-in closets, kitchen islands, balconies, and double vanities. Outside your door, <a href=\"/amenities\">community amenities</a> bring more to your routine: a saltwater pool with poolside WiFi, 24-hour fitness center, coffee bar, clubhouse with billiards, covered lounge, fire pit, courtyard grilling, hibachi station, EV charging, elevators, package lockers, and valet trash.</p><p>When you want to get out, explore nearby Forest Hill Park, the James River Park System, and the growing District 60 area—then come home to connected, courtyard-style living.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019d02f1-5888-765b-803c-f7d3e7bb66e3.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools.",
    "public_id": "019d02f1-5888-765b-803c-f7d3e7bb66e3",
    "storage_key": "property/5695348706115584/019d02f1-5888-765b-803c-f7d3e7bb66e3.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "400",
  "property_year_built": "2016",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.5",
  "property_admin_fee": "199",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Administrative Fee $199\nApplication Fee $50\nPet Fee (Non-Refundable) $350 / pet\nMonthly Pet Rent $35 / pet\nApplication Approval Fee - Starts at $399",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8893812.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://almelementatstonebridge.loftliving.com/login",
  "property_apply_now_url": "https://8893812.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e6a76-223d-7589-a615-169dba5446f2.webp",
  "property_primary_logo_media": {
    "alt_text": "Element at Stonebridge logo",
    "public_id": "019e6a76-223d-7589-a615-169dba5446f2",
    "storage_key": "property/5695348706115584/019e6a76-223d-7589-a615-169dba5446f2.webp",
    "width": 2357,
    "height": 1104
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e6a76-21db-77ff-b194-efeec3c3f8d5.webp",
  "property_secondary_logo_media": {
    "alt_text": "Element at Stonebridge logo",
    "public_id": "019e6a76-21db-77ff-b194-efeec3c3f8d5",
    "storage_key": "property/5695348706115584/019e6a76-21db-77ff-b194-efeec3c3f8d5.webp",
    "width": 2357,
    "height": 1104
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e6a76-2559-7328-a045-5ccbe18eddc0.webp",
  "property_icon_media": {
    "alt_text": "Property Management Company Logo",
    "public_id": "019e6a76-2559-7328-a045-5ccbe18eddc0",
    "storage_key": "property/5695348706115584/019e6a76-2559-7328-a045-5ccbe18eddc0.webp",
    "width": 879,
    "height": 879
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e6a76-2559-7328-a045-5ccbe18eddc0.webp",
  "property_fav_icon_media": {
    "alt_text": "Property Management Company Logo",
    "public_id": "019e6a76-2559-7328-a045-5ccbe18eddc0",
    "storage_key": "property/5695348706115584/019e6a76-2559-7328-a045-5ccbe18eddc0.webp",
    "width": 879,
    "height": 879
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e6a76-2196-7258-b898-b40419c7fa5d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Element at Stonebridge logo",
    "public_id": "019e6a76-2196-7258-b898-b40419c7fa5d",
    "storage_key": "property/5695348706115584/019e6a76-2196-7258-b898-b40419c7fa5d.webp",
    "width": 2357,
    "height": 1104
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150e-b746-70be-a1a9-a409dba537f2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f150e-b746-70be-a1a9-a409dba537f2",
    "storage_key": "property/5695348706115584/019f150e-b746-70be-a1a9-a409dba537f2.webp",
    "width": 1280,
    "height": 599
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#18355e",
  "property_secondary_color": "#7a9abf",
  "property_font_color": "#000000",
  "property_color_4": "#000000",
  "property_color_3": "#6e6e70",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "563 - 1260",
  "property_sqft_min": "563",
  "property_sqft_max": "1260",
  "property_price_range": "1395.16 - 2075",
  "property_price_min": "1395.16",
  "property_price_max": "2075",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/ElementatStonebridge",
  "property_instagram_url": "https://www.instagram.com/liveatelement",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ27wNw48SsYkRaxYryLdxdPc",
  "property_youtube_url": "https://www.youtube.com/watch?v=NvkKABzpmCU&t=57",
  "property_yelp_url": "https://www.yelp.com/biz/element-at-stonebridge-by-boyd-homes-north-chesterfield",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished perks, effortless downtime.</strong> Element at Stonebridge brings the everyday extras into focus with a saltwater pool, landscaped courtyard, fire pit, grilling areas, and a covered TV lounge. Stay active in the 24-hour fitness center, recharge at the clubhouse coffee bar, and simplify the day with EV charging, package lockers, valet trash, and online resident services. Inside, enjoy granite-style counters, stainless steel appliances, hard-surface flooring, smart thermostats, USB outlets, and an included washer and dryer.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room for real life.</strong> Explore one- and two-bedroom apartments in North Chesterfield with open living areas, large windows, granite countertops, stainless steel appliances, and full-size washers and dryers. Select floor plans add kitchen islands, walk-in closets, double vanities, private outdoor space, or vaulted ceilings—giving each home its own standout edge. Browse featured layouts, then click through for current availability and pricing.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a feel for Element at Stonebridge.</strong> Preview polished interiors with sleek kitchen islands, tile backsplashes, stainless-style appliances, wide windows, and hard-surface flooring. Then picture the community details beyond your door—from the pool and lounge to the fire pit, grilling areas, coffee bar, fitness center, and courtyard-style spaces in North Chesterfield.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Everyday convenience with destination energy.</strong> Element at Stonebridge puts coffee, dining, shopping, and errands close by in Stonebridge’s mixed-use setting, with Midlothian Turnpike and Chippenham Parkway nearby for easy Richmond connections. District 60 adds fresh momentum with green space, walkable streetscapes, events, retail, and entertainment, while Bon Air, Forest Hill, and the James River keep local flavor and outdoor escapes within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the service that makes Element at Stonebridge stand out.</strong> Reviews highlight friendly, responsive support from the leasing office, with Jordan Williams often recognized for clear communication, professionalism, and help when it matters most. From smooth move-ins to quick, thoughtful assistance, residents describe a quiet, calm, and welcoming community experience worth reading more about.</p>",
  "property_neighborhood_blurb": "<p><strong>Step into a neighborhood with momentum.</strong> From Element at Stonebridge, errands, coffee runs, and casual meals unfold around Stonebridge’s mixed-use setting, with Midlothian Turnpike and Chippenham Parkway close for connections across Richmond. The area blends everyday convenience with a changing destination feel: District 60 is bringing new green space, walkable streetscapes, events, offices, retail, and entertainment to the corridor, while nearby Bon Air, Forest Hill, and the James River keep local flavor and outdoor options within easy reach. Spend a low-key afternoon browsing nearby shops, meet up for dinner, catch a movie, or map your next park day—then return to an apartment community designed to keep the routine simple. Ready to explore the location in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> and see what’s nearby.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, with room to unwind.</strong> At Element at Stonebridge, amenities are designed to make home feel polished, connected, and genuinely useful—from the saltwater pool and landscaped courtyard to the fire pit, grilling spaces, and covered lounge with TVs. Get movement in at the 24-hour fitness center, settle into the clubhouse or coffee bar, and let practical perks like EV charging, package lockers, online resident services, and valet trash keep the routine running smoothly.</p><p>Inside your North Chesterfield apartment, modern details do the quiet work: granite-style counters, stainless steel appliances, hard-surface flooring, smart thermostats, USB outlets, and an included washer and dryer. Select layouts add kitchen islands, walk-in closets, double vanities, tall ceilings, or outdoor space. See more in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for connected, modern living?</strong> Element at Stonebridge pairs one- and two-bedroom apartments with polished finishes, smart conveniences, and everyday access to shopping, dining, and Richmond destinations. Start your online application today and take the next step toward calling Element at Stonebridge home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Element at Stonebridge?</strong> Contact the leasing team for details on our modern one- and two-bedroom apartments, polished finishes, and connected Stonebridge location. We’re here to help you plan your visit, get directions, or take the next step toward your Richmond apartment search.</p>",
  "property_faqs_blurb": "<p><strong>Have questions about Element at Stonebridge?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living. If you need more details or help finding the right next step, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you move through the day.</strong> Element at Stonebridge offers one- and two-bedroom apartments in North Chesterfield, with options that range from efficient, easy-to-style spaces to larger two-bath homes with extra room to spread out.</p><p>Inside, open living areas, large windows, granite countertops, stainless steel appliances, and a full-size washer and dryer bring practical polish to every floor plan. Select homes add details like kitchen islands, walk-in closets, double vanities, private outdoor space, or dramatic vaulted ceilings—so you can compare the features that matter most before you choose.</p><p>Browse current availability, pricing, and layouts below, then picture how your furniture, routines, and favorite finishing touches could come together here.</p>",
  "property_gallery_blurb": "<p><strong>See how the details come together.</strong> Browse the Element at Stonebridge photo gallery for a closer look at polished apartment interiors, inviting gathering spaces, and courtyard-style amenities in North Chesterfield. Picture a kitchen scene with a sleek island, tile backsplash, and stainless-style appliances; a living area brightened by wide windows and hard-surface flooring; or a bedroom view that hints at smart storage and everyday comfort.</p><p>Keep clicking to explore the <a href=\"/amenities\">amenity spaces</a> that shape the community’s atmosphere—from the pool and lounge to the fire pit, grilling areas, coffee bar, and fitness center. When the photos start to feel like your next backdrop, <a href=\"/schedule-a-tour\">schedule a tour</a> and experience Element at Stonebridge in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Element at Stonebridge.</strong> Use the interactive map to see available one- and two-bedroom apartments, then zoom out to browse nearby shopping, dining, transit access, parks, and major Richmond connections—all from a connected Stonebridge address.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash, the cat tree, and the daily routine.</strong> At Element at Stonebridge, your pets have a place in the plan, with cats and dogs welcome, up to two per home, and no weight limit. Inside, hard-surface flooring, large windows, and an included washer and dryer help make everyday pet care feel easier, while select layouts offer outdoor space for a breath of fresh air.</p><p>Head out for a quick loop around the community, or plan a longer outing to Rockwood Park’s Ruff House Dog Park and nature trails nearby. Have questions about fees or breed guidelines? The leasing team can walk you through the details and help you choose a layout that suits your routine—start with <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Stonebridge lifestyle.</strong> If you love the modern finishes, everyday convenience, and courtyard-style community at Element at Stonebridge, invite a friend to experience it too. Send a referral today and help them find their next one- or two-bedroom apartment in Richmond.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Pay rent, submit maintenance requests, and manage your Element at Stonebridge account in one convenient place—so you can get back to the connected, courtyard-style living and everyday convenience that make home feel easy.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Element at Stonebridge.</strong> As you browse the reviews, one theme comes through clearly: responsive, genuine service makes a difference. Residents repeatedly recognize Jordan Williams in the leasing office for being friendly, professional, and ready to help—from clear move-in communication to last-minute requests and even an unexpected car jump. Reviewers describe the experience as “seamless and stress-free” and call the community “quiet, calm, and welcoming.” If you value helpful communication and a team that takes pride in supporting residents, these reviews offer a firsthand look at the everyday experience here.</p>",
  "property_created_at": "1752256534330",
  "property_scheduletour_blurb": "<p><strong>See Element at Stonebridge in person.</strong> Tour modern one- and two-bedroom apartments with granite countertops, stainless steel appliances, full-size washers and dryers, and smart thermostats—then picture your routine with a saltwater pool, 24-hour fitness center, coffee bar, and courtyard spaces just outside. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The leasing team at Element at Stonebridge will be in touch soon. In the meantime, picture connected courtyard-style living with modern one- and two-bedroom apartments, polished finishes, and everyday conveniences close at hand.</p>",
  "property_virtualtours_blurb": "<p><strong>Take a look around before you arrive.</strong> Element at Stonebridge’s virtual tours let you move through the spaces that shape daily life here, from the Model- 1BR, 1BA apartment to the community tour that ties everything together. Step inside an open living area, scan the kitchen finishes, notice the natural light, and get a better feel for how the layout could work with your routine.</p><p>Then explore the shared spaces at your own pace: the Fitness Center, Clubroom, and Pool, Courtyard, &amp; Grill Area. You can preview the equipment, lounge seating, billiards area, outdoor grilling setup, and poolside courtyard before you <a href=\"/schedule-a-tour\">schedule a tour</a> in Richmond. Want another angle? Browse the <a href=\"/gallery\">photo gallery</a> after your walkthrough.</p>",
  "property_copyright": "2025 All Rights Reserved. Element at Stonebridge",
  "property_seo_title_home": "Element at Stonebridge | Apartments in North Chesterfield, VA",
  "property_seo_description_home": "Discover your perfect home at Element at Stonebridge in North Chesterfield, VA! Explore our diverse floor plans, including spacious one and two-bedroom apartments featuring tall ceilings, walk-in closets, and modern kitchen appliances. Enjoy exceptional amenities like a state-of-the-art fitness center, refreshing pool, and a cozy fire pit. With convenient online resident services and car charging stations, your comfort and lifestyle are our priority. Don't miss out—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in North Chesterfield, VA",
  "property_seo_description_floorplans": "Discover your ideal living space at Element at Stonebridge in North Chesterfield, VA! Explore our thoughtfully designed floor plans, featuring one-bedroom and two-bedroom options. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_seo_title_amenities": "Amenities | North Chesterfield, VA Apartments for Rent",
  "property_seo_description_amenities": "Discover the Element at Stonebridge in North Chesterfield, VA! Choose from spacious one and two-bedroom floor plans and enjoy luxurious amenities like a state-of-the-art fitness center, serene pool, and vibrant resident clubhouse. Unwind at our outdoor fire pit, grab a coffee at the coffee bar, or grill at the hibachi area. With convenient features such as LUXER package lockers, digital thermostats, and in-unit washers and dryers, your comfort is our priority. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in North Chesterfield, VA",
  "property_seo_description_gallery": "Discover your dream home at Element at Stonebridge in North Chesterfield, VA! Explore our spacious one and two-bedroom floor plans, featuring modern amenities like a fire pit, fitness center, and luxurious pools. Enjoy convenient features such as LUXER Package Lockers, digital thermostats, and kitchen islands. With online resident services, a coffee bar, and generous walk-in closets, you'll love the lifestyle here. Picture yourself living at Element at Stonebridge—view our photo gallery now and find your perfect home!",
  "property_seo_title_virtualtours": "Virtual Tours | Element at Stonebridge Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Element at Stonebridge in North Chesterfield, VA! Explore our spacious one and two-bedroom floor plans. Take a virtual tour today and envision your new lifestyle in our vibrant community. Click to start your journey towards modern apartment living!",
  "property_seo_title_interactivemap": "Interactive Map | Element at Stonebridge Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Element at Stonebridge in North Chesterfield, VA! Our vibrant community offers a range of one and two-bedroom floor plans, complete with modern amenities like a fitness center, pool, coffee bar, and LUXER Package Locker. Enjoy features such as tall ceilings, stylish kitchen islands, and convenient online resident services. Explore our interactive community map to check availability, view pricing, and find your perfect home today! Experience comfort and style at Element at Stonebridge, where luxury meets convenience.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Chesterfield, VA",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Element at Stonebridge in North Chesterfield, VA. Explore our diverse floor plans, including one and two-bedroom options, and see what's around our community. Uncover local favorites and nearby points of interest that make our location truly exceptional. Join us today and experience the perfect blend of comfort and convenience!",
  "property_seo_title_contact": "Contact Us | Element at Stonebridge",
  "property_seo_description_contact": "Discover your perfect home at Element at Stonebridge in North Chesterfield, VA! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today and let us help you find your ideal apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in North Chesterfield, VA",
  "property_seo_description_faqs": "\"Discover your perfect home at Element at Stonebridge in North Chesterfield, VA! Explore our diverse floor plans featuring one and two-bedroom apartments, complete with premium amenities like a fitness center, resident clubhouse, and luxurious outdoor spaces. Have questions? Browse our FAQs page to find answers about our community and learn more about our tech-enhanced living with features like digital thermostats and USB outlets. Elevate your lifestyle today!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Chesterfield, VA",
  "property_seo_description_reviews": "Discover the vibrant lifestyle waiting for you at Element at Stonebridge in North Chesterfield, VA! Explore our diverse floor plans, including spacious one and two-bedroom apartments designed for comfort and convenience. Enjoy a wealth of amenities such as a state-of-the-art fitness center, relaxing fire pit, and inviting coffee bar. Our community also features tech-savvy details like USB outlets and digital thermostats, alongside luxurious touches like walk-in closets and private patios. Don't just take our word for it—see what our residents have to say about their living experience! Join us today and elevate your everyday living.",
  "property_seo_title_applynow": "Apply Now | Apartments in North Chesterfield, VA",
  "property_seo_description_applynow": "Discover your perfect home at Element at Stonebridge in North Chesterfield, VA! Choose from spacious one and two-bedroom floor plans featuring modern amenities like a LUXER Package Locker, fitness center, and a relaxing fire pit. Enjoy in-unit conveniences including kitchen appliances, washer & dryer, and USB outlets. Experience a vibrant community with a coffee bar, pool, and resident clubhouse—plus the convenience of leasing online. Find your new home and apply now!",
  "property_seo_title_residentaccess": "Resident Access | Element at Stonebridge",
  "property_seo_description_residentaccess": "\"Welcome to the Element at Stonebridge resident portal! Conveniently access your account to pay rent, schedule maintenance, and stay connected with our North Chesterfield community. Log in now for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Element at Stonebridge",
  "property_seo_description_referafriend": "\"Refer a friend to Element at Stonebridge in North Chesterfield, VA, and build a thriving community together! Great friends make great neighbors—join our vibrant atmosphere and enjoy exclusive rewards. Share the love today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Element at Stonebridge",
  "property_seo_description_scheduletour": "\"Explore your future home at Element at Stonebridge in North Chesterfield, VA! Schedule a tour today to discover our stunning apartments, modern amenities, and vibrant community. Don't miss out—your ideal living space awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Element at Stonebridge",
  "property_seo_description_privacy": "Discover peace of mind at Element at Stonebridge in North Chesterfield, VA. Ensure your privacy with our comprehensive policy detailing how we protect your information. Ready to learn more? View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Element at Stonebridge",
  "property_seo_description_accessibility": "Discover the commitment to accessibility at Element at Stonebridge in North Chesterfield, VA. Our Accessibility Statement highlights our dedication to digital inclusion for all residents and visitors. Join us in creating an inclusive community that values every voice. Learn more today!",
  "property_seo_title_sitemap": "Sitemap | Element at Stonebridge",
  "property_seo_description_sitemap": "Explore the Element at Stonebridge in North Chesterfield, VA! Our sitemap offers a comprehensive overview of our vibrant apartment community, amenities, and nearby attractions. Discover your new home—view our website sitemap today!",
  "property_seo_title_thankyou": "Thank You | Element at Stonebridge",
  "property_seo_description_thankyou": "Thank you for reaching out to Element at Stonebridge in North Chesterfield, VA! We're excited to assist you in finding your perfect apartment. A member of our team will be in touch shortly to answer your questions and provide more information about our vibrant community. Stay tuned for your next step toward elevated living!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319778",
  "amenities": [
    {
      "id": "custom_97141b7d-5574-42e1-a46f-a429dae17a02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a410d43-fb84-4a5b-a0b2-7a0a7b872b09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79f5cd0e-d13c-4c6e-a4bb-cfb8d27bc9bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Wood Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8ed8b00-d351-4169-bbde-e9110f208db9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_110f1e1a-0e93-4ac7-9308-d0dcdb78738d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Gourmet Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_efd5e5bf-97b8-4e87-a914-63d6a9afb4dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops w/Deep Sinks & Chrome Fixtures",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_158b1d4f-fc2c-4755-a9e9-5d0087b64b1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000625",
      "title": "Digital Thermostats",
      "amount": "0.0000",
      "description": "Digital Thermostats",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d10ea1d6-6213-478d-a9f3-05dcfed04d02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000629",
      "title": "Double Vanity",
      "amount": "0.0000",
      "description": "Double Vanity in Primary Bathroom*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f46d8a9-acb0-4ec4-bc84-ea094a90ca33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000630",
      "title": "Elevators",
      "amount": "0.0000",
      "description": "Elevator Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_853ca24c-9e35-4325-bc83-8dbe25df65eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Outdoor Fire Pit",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbb42b4e-858b-4e31-b26c-082ec5ae09be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7ca3cb3-7828-4b80-be9a-2b37aa958a1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9db9f7c7-a8a6-4c7a-af8b-c16b4727e60b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Plank Flooring & Plush Carpets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d81b0767-517a-4ca2-980a-9c16b1e2ae1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000648",
      "title": "Hibachi Grill",
      "amount": "0.0000",
      "description": "Hibachi Grill",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d919d45-a886-4dc1-bf5e-b571ad521f31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1508204a-49f0-4760-91c2-3112bccdbdcd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Kitchen Island*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_45c4e64b-64d1-4e6c-aebe-d5c9c550219e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3eedef6a-7b3e-4e85-9bf0-c57c00790138",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ca6a8c7-0714-4e85-adfe-59976cfa20e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Saltwater Pool w/ Poolside WiFi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54316788-f642-4a81-b173-7579000ecfb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18826a6c-0302-4e86-9438-ea64ec7b466c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70ff27c2-ec2d-4e14-a558-0f82286e6eae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000691",
      "title": "Technology Package",
      "amount": "0.0000",
      "description": "High Speed Internet Bundle",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01151179-bc5e-403d-bfba-7fbe70dd4598",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cd02e84-1787-42cb-ac5c-cda45f3b7139",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB & USC-C Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b50460d-e9d4-4244-a3a8-9af1fa01bf10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0856ebf1-6ff1-4398-8606-f187bc9ac5b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1c05c9c-4d3d-42d8-8356-0ae4dd82668c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000000710",
      "title": "Windows",
      "amount": "0.0000",
      "description": "Large Windows",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6a664ba-7f81-4828-9377-717216df0dfb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "The Cave - Covered Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf157529-1599-4314-92fb-38c5a4b34403",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8ea6b254-cf3d-4032-afaf-f24318a2de11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Clubroom w/ Billiards Table, TVs and Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4fad5e03-18a6-4c24-bc4f-44fd3728e1a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-5d62-70ef-919c-040058acf7a5.webp",
      "image_media": {
        "alt_text": "Apartment building courtyard with an outdoor swimming pool and lounge chairs.",
        "public_id": "019e8994-5d62-70ef-919c-040058acf7a5",
        "storage_key": "property/5695348706115584/019e8994-5d62-70ef-919c-040058acf7a5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs for soaking up the sun.",
      "link": "",
      "alt_text": "Apartment building courtyard with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0cd14b1f-d87f-4747-824e-c574403170dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-61ba-725c-ab2c-737488ecf65f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating.",
        "public_id": "019e8994-61ba-725c-ab2c-737488ecf65f",
        "storage_key": "property/5695348706115584/019e8994-61ba-725c-ab2c-737488ecf65f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and shaded seating areas perfect for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f58a95f2-3f86-4322-8443-5936b8862c64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-5dcc-7698-8f33-fc73ce3d9230.webp",
      "image_media": {
        "alt_text": "A neatly made bed with white linens, gray headboard, and decorative pillows in a well-lit bedroom.",
        "public_id": "019e8994-5dcc-7698-8f33-fc73ce3d9230",
        "storage_key": "property/5695348706115584/019e8994-5dcc-7698-8f33-fc73ce3d9230.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Cozy and stylish bedroom featuring a comfortable bed, elegant decor, and a large window with blinds.",
      "link": "",
      "alt_text": "A neatly made bed with white linens, gray headboard, and decorative pillows in a well-lit bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea349a68-3052-4f95-98bb-a977b9969ba7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-448f-73aa-9e5c-c60051e89a8d.webp",
      "image_media": {
        "alt_text": "Courtyard with fire pit, grills, and seating.",
        "public_id": "019e8994-448f-73aa-9e5c-c60051e89a8d",
        "storage_key": "property/5695348706115584/019e8994-448f-73aa-9e5c-c60051e89a8d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the fire pit or grill with friends in this inviting outdoor courtyard space.",
      "link": "",
      "alt_text": "Courtyard with fire pit, grills, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ca9e64c-2a3c-4a03-9b02-12465fc0bbfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-4a1c-727f-848c-a852ff8c45d3.webp",
      "image_media": {
        "alt_text": "In-unit stacked washer and dryer next to a kitchen and living area.",
        "public_id": "019e8994-4a1c-727f-848c-a852ff8c45d3",
        "storage_key": "property/5695348706115584/019e8994-4a1c-727f-848c-a852ff8c45d3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer, perfect for busy lifestyles. Enjoy the spacious open-concept living area and modern kitchen.",
      "link": "",
      "alt_text": "In-unit stacked washer and dryer next to a kitchen and living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a56927c-d1f9-4cb2-8b40-1f245cbd114c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-3dce-739b-80ec-d471ae2dd155.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019e8994-3dce-739b-80ec-d471ae2dd155",
        "storage_key": "property/5695348706115584/019e8994-3dce-739b-80ec-d471ae2dd155.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio equipment, strength training machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ebf9b84-7b72-42ed-b55b-b0c1c877923b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-3dc7-773c-9677-c6bd437a300f.webp",
      "image_media": {
        "alt_text": "Modern living room with large sectional sofa, coffee table, TV, and abstract art.",
        "public_id": "019e8994-3dc7-773c-9677-c6bd437a300f",
        "storage_key": "property/5695348706115584/019e8994-3dc7-773c-9677-c6bd437a300f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable resident lounge, perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Modern living room with large sectional sofa, coffee table, TV, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4082f81d-f741-4579-8939-a21f9cc805bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-3ffb-74dd-b47d-b5a9904e3e62.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, dining tables, and seating areas.",
        "public_id": "019e8994-3ffb-74dd-b47d-b5a9904e3e62",
        "storage_key": "property/5695348706115584/019e8994-3ffb-74dd-b47d-b5a9904e3e62.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a billiards table, comfortable seating, and gathering spaces.",
      "link": "",
      "alt_text": "Community lounge with a pool table, dining tables, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7b09995-645a-40b6-b92f-807a2000d163",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-3da3-72ac-8b95-396989877317.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and island with sink.",
        "public_id": "019e8994-3da3-72ac-8b95-396989877317",
        "storage_key": "property/5695348706115584/019e8994-3da3-72ac-8b95-396989877317.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring dark wood cabinets, stainless steel appliances, granite countertops, and an island with a sink, seamlessly connected to the living and dining areas.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and island with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e450440-4097-44c6-8ec7-cba2ed15e589",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-43c3-7245-9552-9b977fd44613.webp",
      "image_media": {
        "alt_text": "Stylish living and dining area in an apartment with a TV, large artwork, and a dining table set for dinner.",
        "public_id": "019e8994-43c3-7245-9552-9b977fd44613",
        "storage_key": "property/5695348706115584/019e8994-43c3-7245-9552-9b977fd44613.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed apartment featuring a spacious living and dining area, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Stylish living and dining area in an apartment with a TV, large artwork, and a dining table set for dinner.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c49c6d09-58bb-4b12-8e92-469663ca4a07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-427c-7142-ab11-827d37806054.webp",
      "image_media": {
        "alt_text": "Fitness center with spin bikes, free weights, punching bag, and medicine balls.",
        "public_id": "019e8994-427c-7142-ab11-827d37806054",
        "storage_key": "property/5695348706115584/019e8994-427c-7142-ab11-827d37806054.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weights, and yoga mats for your wellness routine.",
      "link": "",
      "alt_text": "Fitness center with spin bikes, free weights, punching bag, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9109418-cbdc-4da4-bb3d-c0e3592009a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-4098-7033-badf-49eb1e733dc2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019e8994-4098-7033-badf-49eb1e733dc2",
        "storage_key": "property/5695348706115584/019e8994-4098-7033-badf-49eb1e733dc2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, granite countertops, a stainless steel refrigerator, and an island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f041d932-62fd-4b8d-a1ec-9b91a0378496",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-21ff-73ef-bd6e-73da76e877cb.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, coffee table, TV, and access to a balcony.",
        "public_id": "019e8994-21ff-73ef-bd6e-73da76e877cb",
        "storage_key": "property/5695348706115584/019e8994-21ff-73ef-bd6e-73da76e877cb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a plush sectional sofa, modern decor, and ample natural light.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, coffee table, TV, and access to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41124b3f-ec5b-4832-b74c-f7a76e4511c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-2443-7254-a8cd-4e240e7d6e37.webp",
      "image_media": {
        "alt_text": "EV charging stations in apartment complex parking lot.",
        "public_id": "019e8994-2443-7254-a8cd-4e240e7d6e37",
        "storage_key": "property/5695348706115584/019e8994-2443-7254-a8cd-4e240e7d6e37.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Dedicated EV charging stations available for residents, located conveniently in the community parking area.",
      "link": "",
      "alt_text": "EV charging stations in apartment complex parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_758f58ac-5b2e-4de3-add8-65b1692361c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-22b6-7508-8f13-155d29d69c02.webp",
      "image_media": {
        "alt_text": "Treadmills and weight training equipment in a modern apartment complex gym.",
        "public_id": "019e8994-22b6-7508-8f13-155d29d69c02",
        "storage_key": "property/5695348706115584/019e8994-22b6-7508-8f13-155d29d69c02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with treadmills, ellipticals, free weights, and strength training machines.",
      "link": "",
      "alt_text": "Treadmills and weight training equipment in a modern apartment complex gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29a85cd0-b519-416b-a4a0-1324958707ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-2265-73c5-bc3a-68b3aae27810.webp",
      "image_media": {
        "alt_text": "Closet with shelving and laundry baskets.",
        "public_id": "019e8994-2265-73c5-bc3a-68b3aae27810",
        "storage_key": "property/5695348706115584/019e8994-2265-73c5-bc3a-68b3aae27810.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring built-in shelving, laundry baskets, and ample hanging space for your wardrobe.",
      "link": "",
      "alt_text": "Closet with shelving and laundry baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6609c56c-3bbe-495e-b2a5-7410796ffd6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-2268-769d-8955-f4436c05ae8b.webp",
      "image_media": {
        "alt_text": "Package lockers with Element at Stonebridge logo.",
        "public_id": "019e8994-2268-769d-8955-f4436c05ae8b",
        "storage_key": "property/5695348706115584/019e8994-2268-769d-8955-f4436c05ae8b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure package lockers available for residents at Element at Stonebridge.",
      "link": "",
      "alt_text": "Package lockers with Element at Stonebridge logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a4843e4-5046-4729-aec1-3b19c909b55e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-232a-726c-aa7d-eee1e23ed604.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinetry.",
        "public_id": "019e8994-232a-726c-aa7d-eee1e23ed604",
        "storage_key": "property/5695348706115584/019e8994-232a-726c-aa7d-eee1e23ed604.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience the heart of your home in this beautifully appointed kitchen, featuring a spacious island, granite countertops, and sleek stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2a7d2db-1533-4ad4-9b94-fcf6f4d49159",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-262d-771b-b407-2a8eabab35b0.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, navy and white bedding, and a walk-in closet.",
        "public_id": "019e8994-262d-771b-b407-2a8eabab35b0",
        "storage_key": "property/5695348706115584/019e8994-262d-771b-b407-2a8eabab35b0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with plush navy and grey accents, complemented by elegant wall art and ample storage in the walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, navy and white bedding, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_472c4197-fa8d-499a-878c-ba543589eee1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-226a-709f-ad69-846eb00be5d4.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating, tables, and grills.",
        "public_id": "019e8994-226a-709f-ad69-846eb00be5d4",
        "storage_key": "property/5695348706115584/019e8994-226a-709f-ad69-846eb00be5d4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor living with comfortable seating, dining areas, and grilling stations on our spacious patio.",
      "link": "",
      "alt_text": "Outdoor patio with seating, tables, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6697d029-dec3-41f5-8112-82dd8b65833c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-22db-7529-b24d-6e8ceaeedbe1.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with grills and fire pit",
        "public_id": "019e8994-22db-7529-b24d-6e8ceaeedbe1",
        "storage_key": "property/5695348706115584/019e8994-22db-7529-b24d-6e8ceaeedbe1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor living with built-in grills and a cozy fire pit area, perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor courtyard with grills and fire pit",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26752441-6b3c-401f-9032-f84547e1db6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e8994-226b-7555-a546-41ea6c73a458.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, white countertop, stainless steel faucet, large mirror, and white bathtub with shower curtain.",
        "public_id": "019e8994-226b-7555-a546-41ea6c73a458",
        "storage_key": "property/5695348706115584/019e8994-226b-7555-a546-41ea6c73a458.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a dark wood vanity, a bright white countertop with a modern faucet, and a spacious bathtub with a clean white shower curtain. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, white countertop, stainless steel faucet, large mirror, and white bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_05df11a6b33424d249e54d2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Rice Fields",
      "poi_type": "Restaurants",
      "poi_address": "141 Stonebridge Plaza Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a90b-707d-8a6f-25ed72b0fdab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a90b-707d-8a6f-25ed72b0fdab",
        "storage_key": "property/5695348706115584/019f150c-a90b-707d-8a6f-25ed72b0fdab.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://ricefieldva.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4294461219660617752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rice-fields",
      "poi_latitude": "37.4989481",
      "poi_longitude": "-77.5274791",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-298-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_afuKqsTsYkRGNiP67n9mDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_a3b4a49b9277dbeb37422534",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "121 Stonebridge Plaza Ave, North Chesterfield, VA 23236, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a0e0-71a9-9aba-2ee075b615ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a0e0-71a9-9aba-2ee075b615ac",
        "storage_key": "property/5695348706115584/019f150c-a0e0-71a9-9aba-2ee075b615ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.qdoba.com/us/va/north-chesterfield/121-stonebridge-plaza-av?utm_medium=organic&utm_source=google&utm_campaign=google_maps&utm_content=website&utm_term=2864",
      "poi_directions_map_url": "https://maps.google.com/?cid=16775193085133711109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "37.4996409",
      "poi_longitude": "-77.5280593",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-674-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTmd-JESsYkRBef7bTt1zeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_b3a0f525f80a73e46ac19d21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Wingstop",
      "poi_type": "Restaurants",
      "poi_address": "109 Stonebridge Plaza Ave Ste K2, Richmond, VA 23225, USA",
      "poi_short_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_long_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a600-7207-b141-5d9439654eeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a600-7207-b141-5d9439654eeb",
        "storage_key": "property/5695348706115584/019f150c-a600-7207-b141-5d9439654eeb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-1376-richmond-va-23225/menu?y_source=1_NTUyMDc4MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10688124674653231560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "37.4994622",
      "poi_longitude": "-77.5283271",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 804-298-7094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9CGzZESsYkRyBnLc8PYU5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "ec_c00fcc69471537d0a86e7910",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Punjab Kitchen Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "101 Stonebridge Plaza Ave, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual, kid-friendly eatery for traditional Indian dishes, including vegetarian options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-9fa1-7462-88ad-dec94ee67027.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9fa1-7462-88ad-dec94ee67027",
        "storage_key": "property/5695348706115584/019f150c-9fa1-7462-88ad-dec94ee67027.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://punjabkitchenrva.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15902419763180226823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "punjab-kitchen-indian-cuisine",
      "poi_latitude": "37.4993443",
      "poi_longitude": "-77.5283078",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 804-447-2677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3fsjnMTsYkRB0mCHYW-sNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_bf8693dcbcd25974a2eaf03f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "sweetFrog",
      "poi_type": "Restaurants",
      "poi_address": "125 Stonebridge Plaza Ave, Richmond, VA 23225, USA",
      "poi_short_description": "National chain with dozens of flavor combinations of soft-serve frozen yogurt, plus sorbet.",
      "poi_long_description": "National chain with dozens of flavor combinations of soft-serve frozen yogurt, plus sorbet.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a6cc-77a7-aced-88c707248a40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a6cc-77a7-aced-88c707248a40",
        "storage_key": "property/5695348706115584/019f150c-a6cc-77a7-aced-88c707248a40.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.sweetfrog.com/stores/frozen-yogurt-richmond/35401?utm_source=gmb&utm_medium=gmb&utm_campaign=gmb&utm_id=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14827033958032374114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweetfrog",
      "poi_latitude": "37.4996706",
      "poi_longitude": "-77.5279357",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-674-4741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXWal-5ESsYkRYnks7dM0xM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "ec_e850575c1b4be176252400bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "7200 Tim Price Way, Richmond, VA 23225, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a5f0-776b-937e-0b34ce83e2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a5f0-776b-937e-0b34ce83e2b2",
        "storage_key": "property/5695348706115584/019f150c-a5f0-776b-937e-0b34ce83e2b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/va/richmond/2408?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9736062547015052353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "37.5004038",
      "poi_longitude": "-77.5280088",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-276-3629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbXAqPUSsYkRQSzReU1xHYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_39aa1e8ce40c3508cd2ed5b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Krispy Kreme",
      "poi_type": "Restaurants",
      "poi_address": "7130 Tim Price Way, Richmond, VA 23225, USA",
      "poi_short_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_long_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-9eef-75ca-b788-d81e73c163ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9eef-75ca-b788-d81e73c163ef",
        "storage_key": "property/5695348706115584/019f150c-9eef-75ca-b788-d81e73c163ef.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://site.krispykreme.com/va/richmond/7130-tim-price-way?y_source=1_MTE4OTc5NzctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4820448083624254893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krispy-kreme",
      "poi_latitude": "37.500532",
      "poi_longitude": "-77.527266",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-276-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdyp4pESsYkRrd2iAv6r5UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_196b64009a178e1db7ac7865",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "7104 Midlothian Turnpike, Richmond, VA 23225, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a6bf-74ca-bff7-2a4bc1917f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a6bf-74ca-bff7-2a4bc1917f8e",
        "storage_key": "property/5695348706115584/019f150c-a6bf-74ca-bff7-2a4bc1917f8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/va/richmond/7104-midlothian-turnpike?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=601674&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=12072036132745073408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "37.5015632",
      "poi_longitude": "-77.5274907",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-674-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2ad5-76ea-bc98-959fc7dc96af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2ad5-76ea-bc98-959fc7dc96af",
        "storage_key": "property/5695348706115584/019f150d-2ad5-76ea-bc98-959fc7dc96af.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJIUiZA5ISsYkRAFPz_-Z8iKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_ec0fd2e009b721613d768dbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Zaxbys Chicken Fingers & Buffalo Wings",
      "poi_type": "Restaurants",
      "poi_address": "7100 Tim Price Way, Richmond, VA 23225, USA",
      "poi_short_description": "Chain eatery serving up fried chicken fingers, wings, sandwiches & other American comfort food.",
      "poi_long_description": "Chain eatery serving up fried chicken fingers, wings, sandwiches & other American comfort food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a07d-72b6-9bd1-6488fed425ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a07d-72b6-9bd1-6488fed425ab",
        "storage_key": "property/5695348706115584/019f150c-a07d-72b6-9bd1-6488fed425ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zaxbys.com/locations/va/richmond/7100-tim-price-way?utm_source=extnet&utm_medium=organic&utm_campaign=local-listings&utm_content=54901",
      "poi_directions_map_url": "https://maps.google.com/?cid=5217409610529374658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zaxbys-chicken-fingers--buffalo-wings",
      "poi_latitude": "37.50054859999999",
      "poi_longitude": "-77.5267202",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-674-1262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWc0z7Y0TsYkRwgFQ02X2Z0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_e30283d9dbfae7754c4342b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "7106 Midlothian Turnpike, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-9f65-739b-8609-83573dbd0ff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-9f65-739b-8609-83573dbd0ff6",
        "storage_key": "property/5695348706115584/019f150c-9f65-739b-8609-83573dbd0ff6.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://locations.chipotle.com/va/north-chesterfield/7106-midlothian-tpke?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2272",
      "poi_directions_map_url": "https://maps.google.com/?cid=4801915489648275985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "37.5013645",
      "poi_longitude": "-77.5283729",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-292-2995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9bC_GpISsYkREXLuObLUo0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_aae7e9ff7af0ca28572d7f9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Carena's Jamaican Grille",
      "poi_type": "Restaurants",
      "poi_address": "7102 Midlothian Turnpike, Richmond, VA 23225, USA",
      "poi_short_description": "Jerk chicken & other Jamaican specialties in a vibrantly colored space with island-themed murals.",
      "poi_long_description": "Jerk chicken & other Jamaican specialties in a vibrantly colored space with island-themed murals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-aaaa-728d-aa54-b8ec463aa554.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-aaaa-728d-aa54-b8ec463aa554",
        "storage_key": "property/5695348706115584/019f150c-aaaa-728d-aa54-b8ec463aa554.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://carenasrva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18304350278417410888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenas-jamaican-grille",
      "poi_latitude": "37.501659",
      "poi_longitude": "-77.52690160000002",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-422-5375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeSmG-Y0SsYkRSGtk_ZgdBv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_3b9391107d6510a16eca6b28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Abuelita's",
      "poi_type": "Restaurants",
      "poi_address": "6400 Midlothian Turnpike, Richmond, VA 23225, USA",
      "poi_short_description": "Guisos, tortillas & other Mexican specialties furnished in a brick-lined, comfy cantina.",
      "poi_long_description": "Guisos, tortillas & other Mexican specialties furnished in a brick-lined, comfy cantina.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ac87-7555-a36c-77f30cdb54d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ac87-7555-a36c-77f30cdb54d3",
        "storage_key": "property/5695348706115584/019f150c-ac87-7555-a36c-77f30cdb54d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.abuelitasrva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3591141215398179595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abuelitas",
      "poi_latitude": "37.5036516",
      "poi_longitude": "-77.5151521",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-997-2602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_GewnMTsYkRC7MSouhL1jE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d10c757a6446a2d80ba97a2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "150 North Restaurant And Lounge",
      "poi_type": "Restaurants",
      "poi_address": "6856 Midlothian Turnpike #101, Richmond, VA 23225, USA",
      "poi_short_description": "This chill lounge & dining room offers classic Southern dishes & weekday happy hours.",
      "poi_long_description": "This chill lounge & dining room offers classic Southern dishes & weekday happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ad00-7017-b116-84c4e07daff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ad00-7017-b116-84c4e07daff9",
        "storage_key": "property/5695348706115584/019f150c-ad00-7017-b116-84c4e07daff9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.150northrestaurantandlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8569562079548525533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "150-north-restaurant-and-lounge",
      "poi_latitude": "37.5023225",
      "poi_longitude": "-77.52287299999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-447-9424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2acd-73d1-aba3-a9b4975ee027.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2acd-73d1-aba3-a9b4975ee027",
        "storage_key": "property/5695348706115584/019f150d-2acd-73d1-aba3-a9b4975ee027.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58OqfIwSsYkR3csl0E4z7XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_b47b575da760b961546be4d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Palenke Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "6835 Midlothian Turnpike, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ac2d-7443-9abe-acc3657e1ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ac2d-7443-9abe-acc3657e1ce2",
        "storage_key": "property/5695348706115584/019f150c-ac2d-7443-9abe-acc3657e1ce2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13344165377116936733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palenke-bar--grill",
      "poi_latitude": "37.5013037",
      "poi_longitude": "-77.522843",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-528-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65ocvPwTsYkRHRofx7X_L7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_bc3d81083816b22827e54c23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "7000 Tim Price Way, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-aeeb-7585-b2e4-d59ed542931f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-aeeb-7585-b2e4-d59ed542931f",
        "storage_key": "property/5695348706115584/019f150c-aeeb-7585-b2e4-d59ed542931f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/va/north-chesterfield/stonebridge/029/00514?cid=loc_02900514_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2698373583815729283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "37.49881",
      "poi_longitude": "-77.5254394",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-772-8540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0675-74e6-9a41-4e71e750a08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0675-74e6-9a41-4e71e750a08e",
        "storage_key": "property/5695348706115584/019f150a-0675-74e6-9a41-4e71e750a08e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0EZRY4SsYkRg2CiVnqMciU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d3e1d7ba1a8aed8443dc1f1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Virginia ABC",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 Stonebridge Plaza Ave, Richmond, VA 23225, USA",
      "poi_short_description": "State-owned source for spirits, wine and beer, with in-store pickup and delivery options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-aeed-737b-8059-d216200c3b2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-aeed-737b-8059-d216200c3b2e",
        "storage_key": "property/5695348706115584/019f150c-aeed-737b-8059-d216200c3b2e.webp",
        "width": 780,
        "height": 300
      },
      "poi_business_url": "https://www.abc.virginia.gov/stores/159",
      "poi_directions_map_url": "https://maps.google.com/?cid=16570128034730779889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-abc",
      "poi_latitude": "37.4983699",
      "poi_longitude": "-77.52714639999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 804-674-7259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR9CGzZESsYkR8aTewKfr9OU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_695821b026eaca8f0eb84c6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "AT&T Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "129 Stonebridge Plaza Ave, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Retailer providing wireless plans & a range of phones, devices & accessories.",
      "poi_long_description": "Retailer providing wireless plans & a range of phones, devices & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-af63-75fe-8db2-4fe953c93949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-af63-75fe-8db2-4fe953c93949",
        "storage_key": "property/5695348706115584/019f150c-af63-75fe-8db2-4fe953c93949.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.att.com/stores/virginia/north-chesterfield/119924?source=E-g2s10000000000X&wtExtndSource=stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=8162464234005442268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "att-store",
      "poi_latitude": "37.4996962",
      "poi_longitude": "-77.52782359999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-539-5376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRX6NspESsYkR3K65Z_nlRnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cell_phone_store"
    },
    {
      "id": "ec_acaaa44a8a7d66f7a5eae3b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Great Clips",
      "poi_type": "Shopping & Retail",
      "poi_address": "151 Stonebridge Plaza Ave, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b16a-7031-bc98-145e8652e1d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b16a-7031-bc98-145e8652e1d8",
        "storage_key": "property/5695348706115584/019f150c-b16a-7031-bc98-145e8652e1d8.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/va/north-chesterfield/151-stonebridge-plaza-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6726336940094790489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "37.4988852",
      "poi_longitude": "-77.5274319",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-745-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSSM4o0SsYkRWRvwMc-_WF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "ec_70eaf79ba1d8d88acd5df5e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Wingstop",
      "poi_type": "Shopping & Retail",
      "poi_address": "109 Stonebridge Plaza Ave Ste K2, Richmond, VA 23225, USA",
      "poi_short_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_long_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-a600-7207-b141-5d9439654eeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-a600-7207-b141-5d9439654eeb",
        "storage_key": "property/5695348706115584/019f150c-a600-7207-b141-5d9439654eeb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-1376-richmond-va-23225/menu?y_source=1_NTUyMDc4MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10688124674653231560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "37.4994622",
      "poi_longitude": "-77.5283271",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 804-298-7094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0684-77dc-b5be-101a76e45b0d",
        "storage_key": "property/5695348706115584/019f150a-0684-77dc-b5be-101a76e45b0d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9CGzZESsYkRyBnLc8PYU5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "ec_d895fe13b1fc315644582d7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Sheetz",
      "poi_type": "Shopping & Retail",
      "poi_address": "2911 Hathaway Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_long_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b226-7186-9da3-4b344d57edcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b226-7186-9da3-4b344d57edcb",
        "storage_key": "property/5695348706115584/019f150c-b226-7186-9da3-4b344d57edcb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://orders.sheetz.com/findASheetz/store/775",
      "poi_directions_map_url": "https://maps.google.com/?cid=15092097571100986174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheetz",
      "poi_latitude": "37.5386404",
      "poi_longitude": "-77.5194022",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-562-9117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2abb-7000-a4cd-66819ca11e29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2abb-7000-a4cd-66819ca11e29",
        "storage_key": "property/5695348706115584/019f150d-2abb-7000-a4cd-66819ca11e29.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJFTw-3cQTsYkRPosCkcfmcdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_f4785a501f9c715518f31a49",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1214 Westover Hills Blvd, Richmond, VA 23225, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b590-72d8-a9be-92946068f850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b590-72d8-a9be-92946068f850",
        "storage_key": "property/5695348706115584/019f150c-b590-72d8-a9be-92946068f850.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1214+westover+hills+blvd-richmond-va-23225/id=3681",
      "poi_directions_map_url": "https://maps.google.com/?cid=5107526904815324487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "37.5206506",
      "poi_longitude": "-77.4892437",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-230-6335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9XM7jTQSsYkRR41EuqiU4UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_9b116b38ba525ffc5cf9c078",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "9700 Midlothian Turnpike, Richmond, VA 23235, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b2ee-71bf-8eec-463f7dc00257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b2ee-71bf-8eec-463f7dc00257",
        "storage_key": "property/5695348706115584/019f150c-b2ee-71bf-8eec-463f7dc00257.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/va/richmond/9700-midlothian-turnpike?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16723649339010612836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "37.5029183",
      "poi_longitude": "-77.5744911",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-256-3911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoQ-utCxtsYkRZH7s13dWFug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_7f5b85b0f26c7e2c9475de10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "11301 Midlothian Turnpike, Richmond, VA 23235, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b455-7181-bdc8-0f8f72fd8896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b455-7181-bdc8-0f8f72fd8896",
        "storage_key": "property/5695348706115584/019f150c-b455-7181-bdc8-0f8f72fd8896.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/richmond-west/1041",
      "poi_directions_map_url": "https://maps.google.com/?cid=2919942254923300131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.503504",
      "poi_longitude": "-77.6047427",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-897-5711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ59-8qHdtsYkRIz1bpQK4hSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_fb321c82e9c0d4690aded457",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1386 Carmia Way, Richmond, VA 23235, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b33b-707f-903a-4eb1b1493cea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b33b-707f-903a-4eb1b1493cea",
        "storage_key": "property/5695348706115584/019f150c-b33b-707f-903a-4eb1b1493cea.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "https://www.homedepot.com/l/Midlothian/VA/Richmond/23235/4631?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6986950019272982579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.5105907",
      "poi_longitude": "-77.6037234",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-897-9021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVZFysYkRM8AsKgai9mA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_4ff7f0e39904002fedbf47ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "A.M. Davis Elementary School",
      "poi_type": "Education",
      "poi_address": "415 S Providence Rd, Richmond, VA 23236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b9f4-7698-8511-6167243fb48c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b9f4-7698-8511-6167243fb48c",
        "storage_key": "property/5695348706115584/019f150c-b9f4-7698-8511-6167243fb48c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://davises.oneccps.org/o/des",
      "poi_directions_map_url": "https://maps.google.com/?cid=18122360668822142824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "am-davis-elementary-school",
      "poi_latitude": "37.4915488",
      "poi_longitude": "-77.54572089999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-348-8747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_VUGj6YSsYkRaH-nDAOPf_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1d1748decac1642ef55a1189",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Providence Middle School",
      "poi_type": "Education",
      "poi_address": "900 Starlight Ln, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b8a2-7556-83d3-e9b30a28de46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b8a2-7556-83d3-e9b30a28de46",
        "storage_key": "property/5695348706115584/019f150c-b8a2-7556-83d3-e9b30a28de46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.oneccps.org/pvms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4514848741419750689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-middle-school",
      "poi_latitude": "37.4883187",
      "poi_longitude": "-77.54289299999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-674-1355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRcY1KASsYkRIZXxdgL3pz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1b2bb5ab46493b5e2c9afc2c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "James River High School",
      "poi_type": "Education",
      "poi_address": "3700 James River Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b7e2-735d-b3f7-6f582faa1c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b7e2-735d-b3f7-6f582faa1c1f",
        "storage_key": "property/5695348706115584/019f150c-b7e2-735d-b3f7-6f582faa1c1f.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://jamesriverhs.oneccps.org/o/jrhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=2057786195779466517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-river-high-school",
      "poi_latitude": "37.552284",
      "poi_longitude": "-77.649329",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 804-378-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWcqhQiZssYkRFTUjd6S5jhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_5fb52881338e1f41921e985c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Hopkins Road Elementary School",
      "poi_type": "Education",
      "poi_address": "6000 Hopkins Rd, North Chesterfield, VA 23234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-beed-759a-b815-4916dc21951e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-beed-759a-b815-4916dc21951e",
        "storage_key": "property/5695348706115584/019f150c-beed-759a-b815-4916dc21951e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hopkinses.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14485152896583237039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopkins-road-elementary-school",
      "poi_latitude": "37.4359428",
      "poi_longitude": "-77.474164",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-743-3665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0Wb4FCsMsYkRr30QVtCZBck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7b06f7259a5778bc78665248",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Crestwood Elementary School",
      "poi_type": "Education",
      "poi_address": "7600 Whittington Dr, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://crestwoodes.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2183702729382104665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crestwood-elementary-school",
      "poi_latitude": "37.5261377",
      "poi_longitude": "-77.5372212",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-560-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk3x-R-ASsYkRWQ7fBxASTh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_ee214ba344db8f529fb422c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Leave It To Beaver Child Care",
      "poi_type": "Education",
      "poi_address": "730 German School Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-b60e-7589-a4e2-48ac877242c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-b60e-7589-a4e2-48ac877242c5",
        "storage_key": "property/5695348706115584/019f150c-b60e-7589-a4e2-48ac877242c5.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.leaveittobvr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10560655663288481254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leave-it-to-beaver-child-care",
      "poi_latitude": "37.5140743",
      "poi_longitude": "-77.50976159999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-944-8799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvQmoHFoSsYkR5vWGfV_8jpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_58ba3c489af9385e341b6e1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Chesterbrook Academy Preschool",
      "poi_type": "Education",
      "poi_address": "3039 Stony Point Rd, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-bd0f-724c-9ba7-b6aec1e4991c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-bd0f-724c-9ba7-b6aec1e4991c",
        "storage_key": "property/5695348706115584/019f150c-bd0f-724c-9ba7-b6aec1e4991c.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.chesterbrookacademy.com/preschools/va/richmond/stony-point-rd/?utm_medium=directory&utm_source=gmb&utm_campaign=profile&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11939709918461563147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterbrook-academy-preschool",
      "poi_latitude": "37.5401876",
      "poi_longitude": "-77.563299",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-979-2591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDZLElNJssYkRCxEcW-lesqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_a1eb84ea276be24ff12a77dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Robious Middle School",
      "poi_type": "Education",
      "poi_address": "2701 Robious Crossing Dr, Midlothian, VA 23113, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://robiousms.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352199661314595291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robious-middle-school",
      "poi_latitude": "37.5294647",
      "poi_longitude": "-77.6133512",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-378-2510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaUmywq5tsYkR21mr1rlD4wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_34649319737064b98c095a76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "University of Richmond",
      "poi_type": "Education",
      "poi_address": "410 Westhampton Way, Richmond, VA 23173, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-86c0-743a-9173-dca844e613c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-86c0-743a-9173-dca844e613c5",
        "storage_key": "property/5695348706115584/019f1509-86c0-743a-9173-dca844e613c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.richmond.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3533409872184270335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-richmond",
      "poi_latitude": "37.5758243",
      "poi_longitude": "-77.5397192",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-289-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtXlSJ6IUsYkR_91m1Y4xCTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_34821c5c7198ee36d376cfa9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Movieland At Boulevard Square",
      "poi_type": "Entertainment",
      "poi_address": "1301 N Arthur Ashe Blvd, Richmond, VA 23230, USA",
      "poi_short_description": "Relaxed movie theater, including stadium seating and a cafe/bar for beer, wine and other refreshments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c150-745c-ac65-40df385e0ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c150-745c-ac65-40df385e0ed6",
        "storage_key": "property/5695348706115584/019f150c-c150-745c-ac65-40df385e0ed6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.btmcinemas.com/our-locations/x09im-btm-movieland-at-boulevard-sq-richmond-va/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1339424669672329979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movieland-at-boulevard-square",
      "poi_latitude": "37.5671773",
      "poi_longitude": "-77.46726509999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-354-6008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2ac1-749c-b2f0-c0360e4895a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2ac1-749c-b2f0-c0360e4895a3",
        "storage_key": "property/5695348706115584/019f150d-2ac1-749c-b2f0-c0360e4895a3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJx7ZMNKoWsYkR-9I296OXlhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6cd5942b4e38cf9ff2c7f046",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "The Byrd Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2908 W Cary St, Richmond, VA 23221, USA",
      "poi_short_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_long_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c15d-774f-90f5-b6c98ea4ba34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c15d-774f-90f5-b6c98ea4ba34",
        "storage_key": "property/5695348706115584/019f150c-c15d-774f-90f5-b6c98ea4ba34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://byrdtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9894436379511868258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-byrd-theatre",
      "poi_latitude": "37.5522866",
      "poi_longitude": "-77.4779238",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-358-3056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2ac1-749c-b2f0-c0360e4895a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2ac1-749c-b2f0-c0360e4895a3",
        "storage_key": "property/5695348706115584/019f150d-2ac1-749c-b2f0-c0360e4895a3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1T2xOQTsYkRYsuB1XYZUIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_bdcca05bffe4cef0171d81cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "The National",
      "poi_type": "Entertainment",
      "poi_address": "708 E Broad St, Richmond, VA 23219, USA",
      "poi_short_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_long_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c144-734f-8b7a-52a88dd542a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c144-734f-8b7a-52a88dd542a9",
        "storage_key": "property/5695348706115584/019f150c-c144-734f-8b7a-52a88dd542a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thenationalva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004828295590865461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-national",
      "poi_latitude": "37.541897",
      "poi_longitude": "-77.43517",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-612-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UdhNiMRsYkRNWp4tVNK2Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_c31bb15219349ea3405641ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "The Broadberry",
      "poi_type": "Entertainment",
      "poi_address": "2729 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_long_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c1a5-708d-99df-996dfc4c003c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c1a5-708d-99df-996dfc4c003c",
        "storage_key": "property/5695348706115584/019f150c-c1a5-708d-99df-996dfc4c003c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebroadberry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6871247635338204732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadberry",
      "poi_latitude": "37.5616733",
      "poi_longitude": "-77.4695045",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-353-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizauXFURsYkRPJYTpFGTW18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_05d7ed6a09497186de5e94f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Altria Theater",
      "poi_type": "Entertainment",
      "poi_address": "6 N Laurel St, Richmond, VA 23220, USA",
      "poi_short_description": "Sizable theater on the VA Commonwealth campus, offering musicals, concerts, comedy & other events.",
      "poi_long_description": "Sizable theater on the VA Commonwealth campus, offering musicals, concerts, comedy & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c666-72df-a33d-93de393ff51a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c666-72df-a33d-93de393ff51a",
        "storage_key": "property/5695348706115584/019f150c-c666-72df-a33d-93de393ff51a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.altriatheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6861660426167536636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-theater",
      "poi_latitude": "37.5461984",
      "poi_longitude": "-77.4516976",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-592-3368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfBBlEYRsYkR_EsSj82DOV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_6c63701f0428675abd52dfd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Virginia Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "200 N Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_long_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-8a45-774c-a51e-9747a56dc022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-8a45-774c-a51e-9747a56dc022",
        "storage_key": "property/5695348706115584/019f1509-8a45-774c-a51e-9747a56dc022.webp",
        "width": 681,
        "height": 458
      },
      "poi_business_url": "https://vmfa.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4695707663755383770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-museum-of-fine-arts",
      "poi_latitude": "37.5560356",
      "poi_longitude": "-77.4747907",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-340-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06da-75ef-928a-72c8392034f4",
        "storage_key": "property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1Bd8_wTsYkR2hM4wz2BKkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_be1b9da1c5248b88ab270876",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Science Museum of Virginia",
      "poi_type": "Entertainment",
      "poi_address": "2500 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_long_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-8c18-751e-883c-257840ce414f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-8c18-751e-883c-257840ce414f",
        "storage_key": "property/5695348706115584/019f1509-8c18-751e-883c-257840ce414f.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.smv.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10474820232218678101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-museum-of-virginia",
      "poi_latitude": "37.5610827",
      "poi_longitude": "-77.4657929",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-864-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06da-75ef-928a-72c8392034f4",
        "storage_key": "property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9jmx1QRsYkRVRN404AJXpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_c30d210096af10b8ae7a1a1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Virginia Museum of History & Culture",
      "poi_type": "Entertainment",
      "poi_address": "428 N Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "A 1913 neoclassical building houses a research library & expansive collection of Virginia artifacts.",
      "poi_long_description": "A 1913 neoclassical building houses a research library & expansive collection of Virginia artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c8d3-764d-896d-048c2953d8bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c8d3-764d-896d-048c2953d8bd",
        "storage_key": "property/5695348706115584/019f150c-c8d3-764d-896d-048c2953d8bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.virginiahistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=891233438859866386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-museum-of-history--culture",
      "poi_latitude": "37.5582088",
      "poi_longitude": "-77.4736631",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-340-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06da-75ef-928a-72c8392034f4",
        "storage_key": "property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7Khnv4TsYkREjExNxdMXgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ea48a8266c6ec7c5be5ca06a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Maymont",
      "poi_type": "Entertainment",
      "poi_address": "1700 Hampton St, Richmond, VA 23220, USA",
      "poi_short_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_long_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-c65e-738a-acd8-b54a11ce20ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-c65e-738a-acd8-b54a11ce20ad",
        "storage_key": "property/5695348706115584/019f1509-c65e-738a-acd8-b54a11ce20ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maymont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4834827198225545156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maymont",
      "poi_latitude": "37.5341784",
      "poi_longitude": "-77.474571",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8TfDdkTsYkRxHehhLjBGEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8c96a5acbe62fbb7d882b474",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Children's Museum Chesterfield",
      "poi_type": "Entertainment",
      "poi_address": "6629 Lake Harbour Dr, Midlothian, VA 23112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ca5c-770f-9962-7c85e37b2d01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ca5c-770f-9962-7c85e37b2d01",
        "storage_key": "property/5695348706115584/019f150c-ca5c-770f-9962-7c85e37b2d01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmorva.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17384345003090798417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-chesterfield",
      "poi_latitude": "37.4048067",
      "poi_longitude": "-77.6736348",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-474-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06da-75ef-928a-72c8392034f4",
        "storage_key": "property/5695348706115584/019f150a-06da-75ef-928a-72c8392034f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT194Krh2sYkRUWcQkqyZQfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_2b1d6fd4705b75dc205a3b42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c73b-7079-adf5-e380237ce81f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c73b-7079-adf5-e380237ce81f",
        "storage_key": "property/5695348706115584/019f150c-c73b-7079-adf5-e380237ce81f.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06e7-72be-ae5d-6c1ba5ef65e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06e7-72be-ae5d-6c1ba5ef65e4",
        "storage_key": "property/5695348706115584/019f150a-06e7-72be-ae5d-6c1ba5ef65e4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_745d0e1fb25dafce63981533",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Johnston-Willis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 Johnston Willis Dr, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c8b1-7729-86ea-025f5dd92c20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c8b1-7729-86ea-025f5dd92c20",
        "storage_key": "property/5695348706115584/019f150c-c8b1-7729-86ea-025f5dd92c20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/johnston-willis-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18321833032577784974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnston-willis-hospital",
      "poi_latitude": "37.510606",
      "poi_longitude": "-77.5946555",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-483-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06e7-72be-ae5d-6c1ba5ef65e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06e7-72be-ae5d-6c1ba5ef65e4",
        "storage_key": "property/5695348706115584/019f150a-06e7-72be-ae5d-6c1ba5ef65e4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx25C21tsYkRjhzR5BE6RP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_42e721e52796f9f6c7f63d5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c8d8-758d-83ce-bf1bff241986.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c8d8-758d-83ce-bf1bff241986",
        "storage_key": "property/5695348706115584/019f150c-c8d8-758d-83ce-bf1bff241986.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/5001-forest-hill-avenue-richmond-va-23225/storeid=1989?WT.mc_id=LS_GOOGLE_RX_1989",
      "poi_directions_map_url": "https://maps.google.com/?cid=12691097514468981491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5218034",
      "poi_longitude": "-77.4890628",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-232-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2adc-74b9-a58b-ec5f3a300727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2adc-74b9-a58b-ec5f3a300727",
        "storage_key": "property/5695348706115584/019f150d-2adc-74b9-a58b-ec5f3a300727.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyybWwDQSsYkR8zrE9_LVH7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_cb0f7eab1d75871311030b15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1214 Westover Hills Blvd, Richmond, VA 23225, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ce34-77f7-acd2-03ab1aadca3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ce34-77f7-acd2-03ab1aadca3d",
        "storage_key": "property/5695348706115584/019f150c-ce34-77f7-acd2-03ab1aadca3d.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1214+westover+hills+blvd-richmond-va-23225/id=3681",
      "poi_directions_map_url": "https://maps.google.com/?cid=9613431719425760712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "37.5206485",
      "poi_longitude": "-77.48925559999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-230-6335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2adc-74b9-a58b-ec5f3a300727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2adc-74b9-a58b-ec5f3a300727",
        "storage_key": "property/5695348706115584/019f150d-2adc-74b9-a58b-ec5f3a300727.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bZo8TQSsYkRyF3Y9DbFaYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0a0a8f643222d7b1e4bbe8b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Chain fitness center offering a range of equipment, personal training, and 24/7 access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-cd64-74e5-ba8e-5261d87c5896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-cd64-74e5-ba8e-5261d87c5896",
        "storage_key": "property/5695348706115584/019f150c-cd64-74e5-ba8e-5261d87c5896.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/richmond-virginia-3652/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3652",
      "poi_directions_map_url": "https://maps.google.com/?cid=14493859207698867019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "37.5346358",
      "poi_longitude": "-77.52650229999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-404-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWBI3gQTsYkRS2NqWyiIJMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_726217b785165d44f0f5d699",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Lunge Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "6819 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-cbeb-76b3-bd55-d524647f808c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-cbeb-76b3-bd55-d524647f808c",
        "storage_key": "property/5695348706115584/019f150c-cbeb-76b3-bd55-d524647f808c.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4347991580364278279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lunge-yoga",
      "poi_latitude": "37.5372558",
      "poi_longitude": "-77.52062289999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-447-6870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOyJBvQgTsYkRB4oAQk4rVzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_ebaaa31ed7f53d323571e9af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "CORA Physical Therapy Stony Point",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 G Stony Point Rd, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-cf09-70e8-a6b0-ddddfe094d5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-cf09-70e8-a6b0-ddddfe094d5d",
        "storage_key": "property/5695348706115584/019f150c-cf09-70e8-a6b0-ddddfe094d5d.webp",
        "width": 1022,
        "height": 575
      },
      "poi_business_url": "https://www.coraphysicaltherapy.com/location/stony-point-virginia/?utm_source=google_business_profile&utm_medium=organic&utm_campaign=local_listings&utm_content=corahealth214",
      "poi_directions_map_url": "https://maps.google.com/?cid=7558945527706257709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cora-physical-therapy-stony-point",
      "poi_latitude": "37.5389022",
      "poi_longitude": "-77.5642704",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-877-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2kBfsBtsYkRLYl1j-jE5mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_95b54d3ad64c7d55beb37c6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Gold's Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1601 Willow Lawn Dr Ste 3A, Richmond, VA 23230, USA",
      "poi_short_description": "Clean, spacious chain fitness center offering personal training, group exercise and equipment areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-90eb-7152-9b0c-2fa885bcdf0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-90eb-7152-9b0c-2fa885bcdf0b",
        "storage_key": "property/5695348706115584/019f1509-90eb-7152-9b0c-2fa885bcdf0b.webp",
        "width": 606,
        "height": 341
      },
      "poi_business_url": "https://www.goldsgym.com/richmondwillowlawnva/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3218434680437994041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym",
      "poi_latitude": "37.5803515",
      "poi_longitude": "-77.49733499999999",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-285-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZbf5msUsYkROfJNNEotqiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4248486d1857eb7bd7393fe8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Balance Pilates Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2123 Staples Mill Rd, Richmond, VA 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-cfad-76dc-8e84-5944dbdb249a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-cfad-76dc-8e84-5944dbdb249a",
        "storage_key": "property/5695348706115584/019f150c-cfad-76dc-8e84-5944dbdb249a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4063644550600960050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "balance-pilates-training-center",
      "poi_latitude": "37.58787330000001",
      "poi_longitude": "-77.4916324",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-340-1203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvTopwD8UsYkRMqgFTDD3ZDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_efaa9c9d1a107abd943ff7e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Bon Secours Urgent Care, Sauer Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2230 W Broad St Ste 101, Richmond, VA 23220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-d09f-71dc-b897-533d7a42f3d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-d09f-71dc-b897-533d7a42f3d6",
        "storage_key": "property/5695348706115584/019f150c-d09f-71dc-b897-533d7a42f3d6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.bonsecours.com/locations/walk-in-urgent-care/richmond/bon-secours-urgent-care-sauer-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14155564199004845711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-urgent-care-sauer-center",
      "poi_latitude": "37.5596034",
      "poi_longitude": "-77.4618373",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-442-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xptC2wRsYkRj7brvKOqcsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_1e53b7b2cfa6a29255962aac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Forest Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4021 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_long_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-bd16-779f-9e74-4a2c2fe21b49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-bd16-779f-9e74-4a2c2fe21b49",
        "storage_key": "property/5695348706115584/019f1509-bd16-779f-9e74-4a2c2fe21b49.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/forest-hill-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4852190897879243188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-hill-park",
      "poi_latitude": "37.5207992",
      "poi_longitude": "-77.4763246",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-646-0036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ1A5CoSsYkRtNl54ulxVkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e63059fed14903c8ae71e90c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "James River Park Pony Pasture",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Richmond, VA 23225, USA",
      "poi_short_description": "Riverside park featuring scenic trails for biking and hiking, as well as swimming.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-d863-7468-b816-49d5abe2ef56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-d863-7468-b816-49d5abe2ef56",
        "storage_key": "property/5695348706115584/019f150c-d863-7468-b816-49d5abe2ef56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jamesriverpark.org/explore-the-park-pony-pasture/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12267777557924412234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-river-park-pony-pasture",
      "poi_latitude": "37.5506636",
      "poi_longitude": "-77.51756619999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXjOv3UTsYkRSvuXA7HmP6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a57d22a0c3593ac6eea3cd8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Canoe Run Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23227, 600 W 22nd St, Richmond, VA 23225, USA",
      "poi_short_description": "This neighborhood greenspace features a sports field, playground & exercise stations.",
      "poi_long_description": "This neighborhood greenspace features a sports field, playground & exercise stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-e093-7718-9b19-401f074b07b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-e093-7718-9b19-401f074b07b7",
        "storage_key": "property/5695348706115584/019f150c-e093-7718-9b19-401f074b07b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18357491295776379805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canoe-run-park",
      "poi_latitude": "37.522332",
      "poi_longitude": "-77.45693109999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQy9C3cRsYkRnZMTRBLpwv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ae7762785011427dbc8fd07c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "North Bank Trail/ Texas Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1907 Texas Ave, Richmond, VA 23220, USA",
      "poi_short_description": "Remote park featuring basic trails popular with dog walkers & isolated beaches & sunbathing spots.",
      "poi_long_description": "Remote park featuring basic trails popular with dog walkers & isolated beaches & sunbathing spots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-eac4-7188-8119-7fd599c65887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-eac4-7188-8119-7fd599c65887",
        "storage_key": "property/5695348706115584/019f150c-eac4-7188-8119-7fd599c65887.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17601130225111901470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-bank-trail-texas-beach",
      "poi_latitude": "37.5307117",
      "poi_longitude": "-77.4685995",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJreyCU30RsYkRHqUvWa_GQ_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3a8363c9d1af95a4c351435b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Belle Isle",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Belle Isle, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-e165-7022-8cb8-cc341f167a02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-e165-7022-8cb8-cc341f167a02",
        "storage_key": "property/5695348706115584/019f150c-e165-7022-8cb8-cc341f167a02.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12144418279497473606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belle-isle",
      "poi_latitude": "37.5289519",
      "poi_longitude": "-77.45286",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUJYAnIRsYkRRh410RSkiag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_833a3ef2c19c005d0f5f2b09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Brown's Island",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S 7th St, Richmond, VA 23219, USA",
      "poi_short_description": "This open, grassy park on a river island offers city & waterway views, walking paths & concerts.",
      "poi_long_description": "This open, grassy park on a river island offers city & waterway views, walking paths & concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-e405-771a-a726-33d983e43a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-e405-771a-a726-33d983e43a6a",
        "storage_key": "property/5695348706115584/019f150c-e405-771a-a726-33d983e43a6a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.brownsisland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14075259420008706778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "browns-island",
      "poi_latitude": "37.5344269",
      "poi_longitude": "-77.44268160000001",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-788-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwcfZRQRsYkR2vIWW95dVcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c9e500497ec87eb9e74533ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Maymont",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1700 Hampton St, Richmond, VA 23220, USA",
      "poi_short_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_long_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-c65e-738a-acd8-b54a11ce20ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-c65e-738a-acd8-b54a11ce20ad",
        "storage_key": "property/5695348706115584/019f1509-c65e-738a-acd8-b54a11ce20ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maymont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4834827198225545156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maymont",
      "poi_latitude": "37.5341784",
      "poi_longitude": "-77.474571",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8TfDdkTsYkRxHehhLjBGEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_982598979f5e995c05ac6262",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Byrd Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 S Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Picturesque city park offering 3 lakes, a walking path, picnic areas, athletic fields & more.",
      "poi_long_description": "Picturesque city park offering 3 lakes, a walking path, picnic areas, athletic fields & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-e858-74f3-8d29-d1b322da14c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-e858-74f3-8d29-d1b322da14c4",
        "storage_key": "property/5695348706115584/019f150c-e858-74f3-8d29-d1b322da14c4.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/byrd-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837632018604371955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byrd-park",
      "poi_latitude": "37.5427152",
      "poi_longitude": "-77.4795668",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7oHsZILsYkR8y8Y4k1uKLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5c702d8b08cdf339b676f584",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Pocahontas State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10301 E State Pk Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_long_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-f08c-715a-a346-a8e10f5577ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-f08c-715a-a346-a8e10f5577ac",
        "storage_key": "property/5695348706115584/019f150c-f08c-715a-a346-a8e10f5577ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dcr.virginia.gov/state-parks/pocahontas.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=450592607913044015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocahontas-state-park",
      "poi_latitude": "37.3724285",
      "poi_longitude": "-77.57153199999999",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 804-796-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2SslsB0sYkRL-gS7ZbTQAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_6387a33c8834bf0df021d83b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Reedy Creek Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 N Riverside Dr, Richmond, VA 23225, USA",
      "poi_short_description": "Parking lot & staging area for a scenic nature hike along a channel of the James River.",
      "poi_long_description": "Parking lot & staging area for a scenic nature hike along a channel of the James River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ec56-70c9-b5e1-51d5b6f99150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ec56-70c9-b5e1-51d5b6f99150",
        "storage_key": "property/5695348706115584/019f150c-ec56-70c9-b5e1-51d5b6f99150.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15227270792784847381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-trailhead",
      "poi_latitude": "37.5243026",
      "poi_longitude": "-77.46869269999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0731-774f-917b-49ca937dd8f4",
        "storage_key": "property/5695348706115584/019f150a-0731-774f-917b-49ca937dd8f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUx4_eNUTsYkRFSKfxhsiUtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e451483bba2d7a13d87d7560",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Transportation & Transit",
      "poi_address": "7000 Tim Price Way, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-aeeb-7585-b2e4-d59ed542931f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-aeeb-7585-b2e4-d59ed542931f",
        "storage_key": "property/5695348706115584/019f150c-aeeb-7585-b2e4-d59ed542931f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/va/north-chesterfield/stonebridge/029/00514?cid=loc_02900514_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2698373583815729283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "37.49881",
      "poi_longitude": "-77.5254394",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-772-8540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0675-74e6-9a41-4e71e750a08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0675-74e6-9a41-4e71e750a08e",
        "storage_key": "property/5695348706115584/019f150a-0675-74e6-9a41-4e71e750a08e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0EZRY4SsYkRg2CiVnqMciU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f96be63bae7582296bf33dd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Gaskins Road Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Commuter Dr, Glen Allen, VA 23060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-e421-726e-8a72-45dff68a8217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-e421-726e-8a72-45dff68a8217",
        "storage_key": "property/5695348706115584/019f150c-e421-726e-8a72-45dff68a8217.webp",
        "width": 1182,
        "height": 1280
      },
      "poi_business_url": "http://www.virginiadot.org/travel/parkride/home.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2076275039652645799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gaskins-road-park--ride",
      "poi_latitude": "37.6397829",
      "poi_longitude": "-77.5738551",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-367-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2ab6-736a-af4d-9669e7fb5396.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2ab6-736a-af4d-9669e7fb5396",
        "storage_key": "property/5695348706115584/019f150d-2ab6-736a-af4d-9669e7fb5396.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQhBgLdqsYkRp4uB4iVp0Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c8a19aa40004d29cf01a5a58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Willow Lawn Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Virginia 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-f5ff-769e-b602-61d1d722ec52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-f5ff-769e-b602-61d1d722ec52",
        "storage_key": "property/5695348706115584/019f150c-f5ff-769e-b602-61d1d722ec52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3072887149338080283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-lawn-station",
      "poi_latitude": "37.58458",
      "poi_longitude": "-77.49725",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2ad0-7448-9cf8-633df3f0f0e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2ad0-7448-9cf8-633df3f0f0e0",
        "storage_key": "property/5695348706115584/019f150d-2ad0-7448-9cf8-633df3f0f0e0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_ACSWoUsYkRG7Qo25QWpSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_8dfe7172033a4caba983093f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "GRTC",
      "poi_type": "Transportation & Transit",
      "poi_address": "301 E Belt Blvd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-f16f-7070-b230-97dbb4d35a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-f16f-7070-b230-97dbb4d35a49",
        "storage_key": "property/5695348706115584/019f150c-f16f-7070-b230-97dbb4d35a49.webp",
        "width": 1000,
        "height": 380
      },
      "poi_business_url": "http://www.ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451363726910217568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grtc",
      "poi_latitude": "37.5066205",
      "poi_longitude": "-77.478867",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2E1riESsYkRYN06hSX8TuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_8f8b7a017c0d3c82a7981cb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Richmond Staples Mill Road",
      "poi_type": "Transportation & Transit",
      "poi_address": "7519 Staples Mill Rd, Richmond, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-f612-74ca-b328-21b276ba4b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-f612-74ca-b328-21b276ba4b06",
        "storage_key": "property/5695348706115584/019f150c-f612-74ca-b328-21b276ba4b06.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvr",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387222506202384095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-staples-mill-road",
      "poi_latitude": "37.6177745",
      "poi_longitude": "-77.49697019999999",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubZoY7cVsYkR38YuoFNCw0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_59c91bac7b976daa7fd816de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Richmond Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1500 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-fd0e-774e-af8e-d0a507627d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-fd0e-774e-af8e-d0a507627d87",
        "storage_key": "property/5695348706115584/019f150c-fd0e-774e-af8e-d0a507627d87.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvm.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11973413221483929113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-main-street-station",
      "poi_latitude": "37.5351005",
      "poi_longitude": "-77.4287069",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8r0xR4RsYkRGd6DF-MbKqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_66efd6167ff6f1ead3c9b596",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Richmond International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-0241-71c5-9b4c-bbe50408339b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0241-71c5-9b4c-bbe50408339b",
        "storage_key": "property/5695348706115584/019f150d-0241-71c5-9b4c-bbe50408339b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06e7-72be-ae5d-702d5637ae1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06e7-72be-ae5d-702d5637ae1b",
        "storage_key": "property/5695348706115584/019f150a-06e7-72be-ae5d-702d5637ae1b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_9cae3c6a3666cb2c245a3a7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Bon Air Baptist Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "2531 Buford Rd, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-f877-714d-a0ef-a99f0d16e7d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-f877-714d-a0ef-a99f0d16e7d3",
        "storage_key": "property/5695348706115584/019f150c-f877-714d-a0ef-a99f0d16e7d3.webp",
        "width": 825,
        "height": 825
      },
      "poi_business_url": "http://www.bonairbaptist.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17705744204867567395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-air-baptist-church",
      "poi_latitude": "37.5332377",
      "poi_longitude": "-77.5595628",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-272-1475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2acf-7675-8d61-5b32182d7df5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2acf-7675-8d61-5b32182d7df5",
        "storage_key": "property/5695348706115584/019f150d-2acf-7675-8d61-5b32182d7df5.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUCgqysTsYkRI_8Pl4twt_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "ec_aa8564bce8f8c6bb83691d8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Commonwealth Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4600 Commonwealth Centre Pkwy, Midlothian, VA 23112, USA",
      "poi_short_description": "Shopping mall with anchor stores, a bowling alley, movie theater, and market.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-fc9a-73f4-aa5d-96e3a321c083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-fc9a-73f4-aa5d-96e3a321c083",
        "storage_key": "property/5695348706115584/019f150c-fc9a-73f4-aa5d-96e3a321c083.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sitecenters.com/properties/commonwealth-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9333911771862754521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonwealth-center",
      "poi_latitude": "37.4187839",
      "poi_longitude": "-77.6321802",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 29 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 877-225-5337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06dc-7238-bfb7-6ea2376a4d89",
        "storage_key": "property/5695348706115584/019f150a-06dc-7238-bfb7-6ea2376a4d89.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGyqMW_FzsYkR2WS3pk23iIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ebbb3854a5e0cf850545f916",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Hickory Haven Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "2031 Ashland Rd, Rockville, VA 23146, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-ffc9-760d-a212-f4dda7eec3fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-ffc9-760d-a212-f4dda7eec3fa",
        "storage_key": "property/5695348706115584/019f150c-ffc9-760d-a212-f4dda7eec3fa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.virginiadot.org/travel/parkride/home.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17098545202861201730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hickory-haven-park--ride",
      "poi_latitude": "37.6853404",
      "poi_longitude": "-77.6670555",
      "poi_miles_from_property": "20.9 mi",
      "poi_walking_minutes": "7 hours 44 mins",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-2ab6-736a-af4d-9669e7fb5396.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2ab6-736a-af4d-9669e7fb5396",
        "storage_key": "property/5695348706115584/019f150d-2ab6-736a-af4d-9669e7fb5396.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJyygmDhdCsYkRQlmAIEU8Su0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_378ec872a9afdd93ec4c4753",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7101 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150c-c73b-7079-adf5-e380237ce81f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-c73b-7079-adf5-e380237ce81f",
        "storage_key": "property/5695348706115584/019f150c-c73b-7079-adf5-e380237ce81f.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06e7-72be-ae5d-6c1ba5ef65e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06e7-72be-ae5d-6c1ba5ef65e4",
        "storage_key": "property/5695348706115584/019f150a-06e7-72be-ae5d-6c1ba5ef65e4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_8b089607db5da59abdf80ce0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Defense Logistics Agency",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6090 Strathmore Rd, Richmond, VA 23237, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-0ab1-7138-a3ca-550fb9c0d07a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0ab1-7138-a3ca-550fb9c0d07a",
        "storage_key": "property/5695348706115584/019f150d-0ab1-7138-a3ca-550fb9c0d07a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dla.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15167558755148570127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "defense-logistics-agency",
      "poi_latitude": "37.4408583",
      "poi_longitude": "-77.4522037",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-279-3861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-CVg-gOsYkRDx5_nlP-fdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_c7441b35cdb04a1dc6269160",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "University of Richmond",
      "poi_type": "Major Employers & Offices",
      "poi_address": "410 Westhampton Way, Richmond, VA 23173, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f1509-86c0-743a-9173-dca844e613c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-86c0-743a-9173-dca844e613c5",
        "storage_key": "property/5695348706115584/019f1509-86c0-743a-9173-dca844e613c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.richmond.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3533409872184270335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-richmond",
      "poi_latitude": "37.5758243",
      "poi_longitude": "-77.5397192",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-289-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtXlSJ6IUsYkR_91m1Y4xCTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0bb11c5612294500bb355075",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Virginia Commonwealth University Undergraduate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "912 W Grace St, Richmond, VA 23284, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-0ab9-708c-9744-42ba22fa0f75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0ab9-708c-9744-42ba22fa0f75",
        "storage_key": "property/5695348706115584/019f150d-0ab9-708c-9744-42ba22fa0f75.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://admissions.vcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15126664863483404071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-commonwealth-university-undergraduate",
      "poi_latitude": "37.5505241",
      "poi_longitude": "-77.4517152",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-828-1222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0669-76e0-97ca-2bf409468960",
        "storage_key": "property/5695348706115584/019f150a-0669-76e0-97ca-2bf409468960.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3Le1yMRsYkRJ59PgIy17NE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_c31bd2ca534c2d38fee0988c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Richmond International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-0f5f-7113-b113-56c1294bbca8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0f5f-7113-b113-56c1294bbca8",
        "storage_key": "property/5695348706115584/019f150d-0f5f-7113-b113-56c1294bbca8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-06e7-72be-ae5d-702d5637ae1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-06e7-72be-ae5d-702d5637ae1b",
        "storage_key": "property/5695348706115584/019f150a-06e7-72be-ae5d-702d5637ae1b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_a0d4eeb2c68299840a705b61",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Chesterfield County Govt Ofcs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9901 Lori Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chesterfield.gov/27/Departments",
      "poi_directions_map_url": "https://maps.google.com/?cid=12063357218050306170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-county-govt-ofcs",
      "poi_latitude": "37.3765559",
      "poi_longitude": "-77.50781429999999",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-748-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-073e-7554-9315-85fa2a83e902.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-073e-7554-9315-85fa2a83e902",
        "storage_key": "property/5695348706115584/019f150a-073e-7554-9315-85fa2a83e902.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cCVY6ILsYkRenCItHmnaac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_b78743c616b3b59907d80413",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Western Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "JFHM+3M, 4305 E Parham Rd, Richmond, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-15b0-77c6-8d69-d50e85556ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-15b0-77c6-8d69-d50e85556ecf",
        "storage_key": "property/5695348706115584/019f150d-15b0-77c6-8d69-d50e85556ecf.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://henrico.us/registrar/about-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2080687208423985852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-government-center",
      "poi_latitude": "37.6281091",
      "poi_longitude": "-77.5148562",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 804-501-4347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-073e-7554-9315-85fa2a83e902.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-073e-7554-9315-85fa2a83e902",
        "storage_key": "property/5695348706115584/019f150a-073e-7554-9315-85fa2a83e902.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3o4gwoVsYkRvJLP-v0V4Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_87b5870919dee39630b52d69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Altria Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6601 W Broad St, Richmond, VA 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-14f4-7746-9821-a1c72e8f401f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-14f4-7746-9821-a1c72e8f401f",
        "storage_key": "property/5695348706115584/019f150d-14f4-7746-9821-a1c72e8f401f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.altria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996391984863159021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-headquarters",
      "poi_latitude": "37.60063239999999",
      "poi_longitude": "-77.5167464",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITmtbfgUsYkR7aJIUg7jHdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_a59301884294b322543d9dec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "Dominion Energy Virginia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120 Tredegar St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-1a69-74df-b505-ad52dac88d25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-1a69-74df-b505-ad52dac88d25",
        "storage_key": "property/5695348706115584/019f150d-1a69-74df-b505-ad52dac88d25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dominionenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11041679550737667097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominion-energy-virginia",
      "poi_latitude": "37.533753",
      "poi_longitude": "-77.4537127",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-366-4357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2CeDWwRsYkRGdRp0QztO5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_388feacc58e2a06860b29bf6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "poi_name": "CarMax Home Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12800 Tuckahoe Creek Pkwy, Richmond, VA 23238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150d-223d-77cc-9d69-3c78d1380829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-223d-77cc-9d69-3c78d1380829",
        "storage_key": "property/5695348706115584/019f150d-223d-77cc-9d69-3c78d1380829.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carmax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2609920891388220952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carmax-home-office",
      "poi_latitude": "37.6393791",
      "poi_longitude": "-77.67147969999999",
      "poi_miles_from_property": "34.2 mi",
      "poi_walking_minutes": "12 hours 34 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 804-747-0422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-0736-7123-b8d8-93b4e1cc1f77",
        "storage_key": "property/5695348706115584/019f150a-0736-7123-b8d8-93b4e1cc1f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJocjWXZdpsYkRGNYQBzlNOCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_837c09c5-f0e4-4887-b041-106d58440481",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6042642d-5782-4fa9-9cd7-e89d4b229bc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b28dd0d7-2d69-4f50-a9bb-3dfc13fd394b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_55a12eb4-daf2-41d9-b16e-9f109e084aa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_365c54d0-9431-4965-ab6d-e488ba04e090",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1d92e891-3ea8-4119-81d6-eccfe3065008",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8a355376-8cd6-4e92-9e3b-ddc74acc3e46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "rating": "5.0",
      "name": "Rachael Kamara",
      "text": "Jordan Williams at the leasing office has been incredibly helpful, especially during my move-in. He's always ready to assist with any needs or questions I have. Whether he's interacting with potential or current residents, he's consistently friendly and welcoming. I'm not sure if he's the manager, but he handles everything with such competence and warmth.\n\nNo matter how tired he might be, he’s always open to helping with anything. I'm so grateful for his assistance and happy to be living in such a quiet, calm, and welcoming community. Jordan’s positive attitude truly enhances the living experience here.",
      "date": "2025-12-05",
      "title": ""
    },
    {
      "id": "custom_aeeb9c22-fb0a-4f65-bd69-492ea1423e0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "rating": "5.0",
      "name": "Dasia Johnson",
      "text": "I just wanted to write a review and shout out Jordan Williams! Last year, I had some car troubles and needed to jumpstart my car. I went in the leasing office to ask and Jordan was more than happy to help. He immediately came out and helped me jump my car, and also gave a few helpful tips! I know this review is a bit late because this occurred last year, so I’m sorry about that, but I had to shout him out for helping me with my car, but also any time I come in the leasing office he’s always friendly and willing to help out in any way he can! I truly appreciate it! Thank you Jordan!",
      "date": "2026-01-28",
      "title": ""
    },
    {
      "id": "custom_994ac6d7-7ef1-4936-83e9-dde514cc8ac7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "rating": "5.0",
      "name": "Hunter Astrop",
      "text": "I can’t say enough good things about my experience with Jordan, my leasing manager. From day one, he was professional, transparent, and genuinely helpful throughout the entire move-in process. His communication was always clear and consistent, and he made sure I had everything I needed to feel confident about my new home. It’s rare to find someone who takes this much pride in their work — Jordan truly made the experience seamless and stress-free.",
      "date": "2025-10-30",
      "title": ""
    },
    {
      "id": "custom_90d74de0-badc-47ff-92ed-64a6503ecbf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "rating": "5.0",
      "name": "Iam. Rawn",
      "text": "Jordan Williams  has been AWESOME. He goes above and beyond to ensure his residents are well taken care of and comfortable. He is very Professional, efficient and has helped me with any and all last minute requests prior to my move in date this past week. He’s been great as my leasing manager but he’s an even better human being. It’s hard to find such genuine individuals like him.",
      "date": "2025-11-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f91ef9f4858e07daeaf85e99",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f14c4-5ea2-72cc-8d84-242824ae5089.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-5ea2-72cc-8d84-242824ae5089",
        "storage_key": "property/5695348706115584/019f14c4-5ea2-72cc-8d84-242824ae5089.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Model- 1BR, 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wUaubMSAZRp"
    },
    {
      "id": "ec_25040c413a0ba9778b20e674",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f14c4-5e27-72cf-9948-fc5d25721370.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-5e27-72cf-9948-fc5d25721370",
        "storage_key": "property/5695348706115584/019f14c4-5e27-72cf-9948-fc5d25721370.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Element at Stonebridge | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/yAGMR25fX50"
    },
    {
      "id": "ec_af7d160ea2de96ba1ab26563",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f14c4-6004-779c-a4b1-00f3cfee3386.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-6004-779c-a4b1-00f3cfee3386",
        "storage_key": "property/5695348706115584/019f14c4-6004-779c-a4b1-00f3cfee3386.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Lue8LNRDZbD"
    },
    {
      "id": "ec_9439089b0cfc0adaf99306db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f14c4-670a-7649-863f-781418e760f5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-670a-7649-863f-781418e760f5",
        "storage_key": "property/5695348706115584/019f14c4-670a-7649-863f-781418e760f5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GAUe8wqGDf3"
    },
    {
      "id": "ec_b9ead9cefa02e093b0144bc8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f14c4-6669-74f3-8116-ba99226d5d58.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-6669-74f3-8116-ba99226d5d58",
        "storage_key": "property/5695348706115584/019f14c4-6669-74f3-8116-ba99226d5d58.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool, Courtyard, & Grill Area",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cGBh1zFyiqi"
    }
  ],
  "faqs": [
    {
      "id": "custom_6cfde734-34df-4425-90b8-df525fe18d2d",
      "question": "Is Element at Stonebridge pet-friendly?",
      "answer": "Yes. Element at Stonebridge welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (804) 571-2787 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_6da0158c-1656-4687-b60a-06507deb1c9e",
      "question": "How can I schedule a tour at Element at Stonebridge?",
      "answer": "You can schedule a tour of Element at Stonebridge online through our Schedule a Tour page, or call the leasing office at (804) 571-2787. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_2ace69df-0cc9-4ea3-bb4f-86ac45825732",
      "question": "What are the leasing office hours at Element at Stonebridge?",
      "answer": "The Element at Stonebridge leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (804) 571-2787 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_707e482b-2131-4bf8-9fd2-1d8fa6bc43d1",
      "question": "What floor plans are available at Element at Stonebridge?",
      "answer": "Element at Stonebridge offers 1- and 2-bedroom apartment homes ranging from approximately 563 to 1,260 square feet, across 8 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_41a0a6b9-1520-4e3d-9d77-c2d27e95e1c1",
      "question": "What amenities does Element at Stonebridge have?",
      "answer": "Element at Stonebridge offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, American Landmark 360, Car Charging Stations, Coffee Bar, Elevators, Fire Pit, Fitness Center, Grill Area, Hibachi Grill, Online Resident Services, Pool, Technology Package, Lounge, Valet Trash Service, and Resident Clubhouse. In-home features include: cabinets, counters, digital thermostats, double vanity, hard floors, kitchen appliances, kitchen islands, outside space, select homes, tall ceilings, tile backsplash, usb outlet, w&d included, walk-in closet, and windows. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_f9372493-d08a-494a-a147-e11393f5eda6",
      "question": "Where is Element at Stonebridge located?",
      "answer": "Element at Stonebridge is located at 301 Karl Linn Dr, Richmond VA 23225. Nearby you'll find dining at Rice Fields, shopping at Kroger Marketplace, and green space at Forest Hill Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_da9e4255-90c8-482b-b90b-7cb45cc73efa",
      "question": "How do I apply to live at Element at Stonebridge?",
      "answer": "You can apply to live at Element at Stonebridge online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (804) 571-2787 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_7de5504f-452b-4e20-86a2-ebbdd74d0d69",
      "question": "What do I need to apply at Element at Stonebridge?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Element at Stonebridge leasing team at (804) 571-2787 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_9bb0911b-7e2f-4204-889c-6fb0c5040ab2",
      "question": "What is the Landmark 360 program at Element at Stonebridge?",
      "answer": "Element at Stonebridge participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (804) 571-2787 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_e79d892d-7046-4168-9a10-d0e46a03dcf7",
      "question": "Does Element at Stonebridge have a pool?",
      "answer": "Yes. Element at Stonebridge has a swimming pool for residents. See it alongside our other community amenities on the Amenities page, or take a look in our virtual tour of the pool.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_ef5e5ea8-4a03-4776-81db-708559954f88",
      "question": "Does Element at Stonebridge have a fitness center?",
      "answer": "Yes. Element at Stonebridge has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_0d3cf555-3e5a-431f-873b-10208f6824bd",
      "question": "Does Element at Stonebridge offer virtual tours?",
      "answer": "Yes. Element at Stonebridge offers virtual tours of Model- 1BR, 1BA, Element at Stonebridge | Community Tour, Fitness Center, Clubroom, and Pool, Courtyard, & Grill Area. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_efb4befb-218d-4cdc-b497-915769f864b8",
      "question": "What do residents say about living at Element at Stonebridge?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Element at Stonebridge. One resident wrote: *\"Jordan Williams at the leasing office has been incredibly helpful, especially during my move-in. He's always ready to assist with any needs or questions I have.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_b70dcd45-1d39-4d5c-a995-992b0d14117c",
      "question": "When was Element at Stonebridge built?",
      "answer": "Element at Stonebridge was built in 2016 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_dc0d2098-55bf-4fc8-a8ea-d65ffecffd01",
      "question": "What is the pet fee at Element at Stonebridge?",
      "answer": "Pets at Element at Stonebridge: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (804) 571-2787 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_a0de4cb0-6d33-40ce-a448-42c3b9a554f0",
      "question": "What features are included in the apartments at Element at Stonebridge?",
      "answer": "Apartment homes at Element at Stonebridge include cabinets, counters, digital thermostats, double vanity, hard floors, kitchen appliances, kitchen islands, outside space, select homes, tall ceilings, tile backsplash, usb outlet, w&d included, walk-in closet, and windows. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_62a210e7-4930-4a72-bfd0-1d4d28b12b90",
      "question": "What restaurants and shops are near Element at Stonebridge?",
      "answer": "Nearby restaurants and shops include Rice Fields, QDOBA Mexican Eats, Wingstop, and Punjab Kitchen Indian Cuisine. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-6ce3-77de-8173-de8669cd054c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "element-at-stonebridge",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584"
    },
    {
      "lead_collector_id": "0198aa45-6d44-766d-9d80-064b74eb89fb",
      "lead_source": "FACEBOOK_ADS",
      "name": "element-at-stonebridge",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584"
    },
    {
      "lead_collector_id": "0198aa45-6da6-700a-bf4e-f2c7831a4027",
      "lead_source": "LANDING_PAGE",
      "name": "element-at-stonebridge",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-north-chesterfield-va",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Reyond Community College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In North Chesterfield VA Near Reyond Community College",
      "h2_subtitle": "Element at Stonebridge offers spacious living in a prime location. Enjoy the convenience of being close to Reyond Community College and local amenities.",
      "page_copy": "Element at Stonebridge is your ideal choice for apartments for rent in North Chesterfield VA near Reyond Community College. Our community features spacious 1 to 2 bedroom apartments nestled in three charming courtyard-style buildings. Located at 301 Karl Linn Drive, our residents enjoy easy access to educational opportunities and the vibrant local scene. \n\nWhether you're a student or a professional, Element at Stonebridge provides a perfect blend of comfort and convenience. With modern amenities and a welcoming atmosphere, you'll find everything you need to feel at home. Schedule a tour today and see why our community is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near Reyond Community College",
      "seo_description": "Explore Element at Stonebridge for apartments for rent in North Chesterfield VA near Reyond Community College. Spacious 1-2 bedrooms in a prime location. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-north-chesterfield-va",
      "search_query": "One Bedroom Apartments For Rent In North Chesterfield VA Near Richmond",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In North Chesterfield VA Near Richmond",
      "h2_subtitle": "Element at Stonebridge offers spacious one-bedroom apartments in a serene courtyard setting. Experience comfortable living near Richmond with modern amenities.",
      "page_copy": "Element at Stonebridge is your destination for one bedroom apartments for rent in North Chesterfield VA near Richmond. Our community features three courtyard-style buildings, providing a peaceful and inviting atmosphere. Each apartment is designed with your comfort in mind, offering spacious layouts and modern amenities to enhance your living experience. \n\nLocated just a short drive from Richmond, Element at Stonebridge combines convenience with tranquility. Enjoy easy access to local dining, shopping, and entertainment options while residing in a community that prioritizes your comfort and satisfaction. Schedule a tour today to see why our one-bedroom apartments are the perfect choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | One Bedroom Apartments For Rent In North Chesterfield VA Near Richmond",
      "seo_description": "Explore Element at Stonebridge for one bedroom apartments for rent in North Chesterfield VA near Richmond. Spacious layouts and modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-university-richmond",
      "search_query": "Apartments For Rent In North Chesterfield VA Near University of Richmond",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In North Chesterfield VA Near University of Richmond",
      "h2_subtitle": "Element at Stonebridge offers a unique living experience with spacious 1 to 2 bedroom apartments. Enjoy the convenience of being close to the University of Richmond.",
      "page_copy": "Element at Stonebridge is your ideal choice for apartments for rent in North Chesterfield VA near University of Richmond. Our community features three courtyard-style buildings, providing a serene and welcoming environment. Each apartment is designed with your comfort in mind, offering spacious layouts and modern amenities. Located at 301 Karl Linn Drive, our community is perfectly situated to give you easy access to the University of Richmond and the vibrant local area. Whether you're a student or a professional, you'll appreciate the convenience and lifestyle that Element at Stonebridge provides. Schedule a tour today and see why our apartments are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near University of Richmond",
      "seo_description": "Explore Element at Stonebridge for apartments for rent in North Chesterfield VA near University of Richmond. Spacious 1-2 bedrooms in a prime location. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "spacious-two-bedrooms-apartments-for-rent-north-chesterfield-va",
      "search_query": "Two Bedrooms Apartments For Rent In North Chesterfield VA",
      "category": "Floorplan",
      "h1_title": "Spacious Two Bedrooms Apartments For Rent In North Chesterfield VA",
      "h2_subtitle": "Element at Stonebridge offers spacious two-bedroom apartments with modern amenities. Enjoy a vibrant community and convenient location in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge presents two bedrooms apartments for rent in North Chesterfield VA, designed with granite countertops and stainless steel appliances for a modern touch. Each apartment is equipped with a full-size washer/dryer, ensuring ease and comfort. Residents can unwind on their private patio or balcony, enjoying the serene environment. The community features a saltwater pool, a courtyard with a firepit, and a 24-hour fitness center, providing ample opportunities for relaxation and fitness. Situated within the Stonebridge Shopping Center, Element at Stonebridge offers easy access to downtown Richmond and Richmond’s West End, with convenient transportation options via the GRTC bus line and Chippenham Parkway.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Two Bedrooms Apartments For Rent In North Chesterfield VA",
      "seo_description": "Find two bedrooms apartments for rent in North Chesterfield VA at Element at Stonebridge. Enjoy modern living with top amenities and a prime location near shopping and dining.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at Element at Stonebridge",
      "h2_subtitle": "Element at Stonebridge offers luxurious living with a saltwater pool and modern amenities. Enjoy a vibrant community in a prime North Chesterfield location.",
      "page_copy": "Element at Stonebridge is your destination for apartments for rent near me with pool, offering a refreshing saltwater pool perfect for relaxation and leisure. Our community features a covered lounge with two 65’’ televisions, a courtyard with a firepit, and six on-site gas grills, providing a vibrant social atmosphere. Each apartment home is equipped with granite countertops, stainless steel appliances, and a full-size washer/dryer, ensuring a comfortable living experience. Located within the Stonebridge Shopping Center, Element at Stonebridge offers easy access to downtown Richmond and Richmond’s West End, with convenient transportation options via the GRTC bus line and Chippenham Parkway. Enjoy the convenience of a 24-hour fitness center and EV charging stations, making Element at Stonebridge the ideal choice for modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent Near Me with Pool",
      "seo_description": "Discover apartments for rent near me with pool at Element at Stonebridge. Enjoy modern amenities and a prime location in North Chesterfield, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Fitness Center at Element at Stonebridge",
      "h2_subtitle": "Element at Stonebridge offers modern apartments with a 24-hour fitness center. Enjoy a convenient lifestyle in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge is the perfect choice for those seeking apartments for rent near me with fitness center, featuring a state-of-the-art 24-hour fitness center that eliminates the need for a gym membership. Our community offers a variety of amenities, including a saltwater pool, a courtyard with a firepit, and a covered lounge with two 65’’ televisions, ensuring a vibrant and active lifestyle. Each apartment home is designed with granite countertops, stainless steel appliances, and a full-size washer/dryer for your convenience. Located within the Stonebridge Shopping Center, Element at Stonebridge provides easy access to downtown Richmond and Richmond’s West End, with transportation options via the GRTC bus line and Chippenham Parkway. Experience modern living with EV charging stations and more at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Element at Stonebridge. Enjoy modern amenities and a prime location in North Chesterfield, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-north-chesterfield-va",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Chippenham Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In North Chesterfield VA Near Chippenham Hospital",
      "h2_subtitle": "Element at Stonebridge offers modern living close to Chippenham Hospital. Enjoy convenient amenities and a prime location in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge is your ideal choice for apartments for rent in North Chesterfield VA near Chippenham Hospital, offering easy access to Richmond's premier medical facility. Our community features 1-to-2-bedroom apartment homes with granite countertops, stainless steel appliances, and full-size washer/dryer in every unit. Residents can enjoy a private patio or balcony, perfect for relaxation. The community amenities include a saltwater pool, a courtyard with a firepit, and a 24-hour fitness center, providing a vibrant and active lifestyle. Located within the Stonebridge Shopping Center, Element at Stonebridge is just a short drive from downtown Richmond and Richmond’s West End, with convenient access to the GRTC bus line and Chippenham Parkway. Experience modern living with EV charging stations, a covered lounge, and more at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near Chippenham Hospital",
      "seo_description": "Discover apartments for rent in North Chesterfield VA near Chippenham Hospital at Element at Stonebridge. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-north-chesterfield-va-near-college",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Brightpoint Community College",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In North Chesterfield VA Near Brightpoint Community College",
      "h2_subtitle": "Element at Stonebridge offers modern living close to Brightpoint Community College. Enjoy convenient amenities and a prime location in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge is your ideal choice for apartments for rent in North Chesterfield VA near Brightpoint Community College, providing easy access to educational opportunities. Our community features 1-to-2-bedroom apartment homes with granite countertops, stainless steel appliances, and full-size washer/dryer in every unit. Residents can enjoy a private patio or balcony, perfect for relaxation. The community amenities include a saltwater pool, a courtyard with a firepit, and a 24-hour fitness center, offering a vibrant and active lifestyle. Located within the Stonebridge Shopping Center, Element at Stonebridge is just a short drive from downtown Richmond and Richmond’s West End, with convenient access to the GRTC bus line and Chippenham Parkway. Experience modern living with EV charging stations, a covered lounge, and more at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near Brightpoint Community College",
      "seo_description": "Discover apartments for rent in North Chesterfield VA near Brightpoint Community College at Element at Stonebridge. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "find-apartments-rent-north-chesterfield-va-near-james-river-high",
      "search_query": "Apartments For Rent In North Chesterfield VA Near James River High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In North Chesterfield VA Near James River High School",
      "h2_subtitle": "Element at Stonebridge offers family-friendly living just 14.4 km from James River High School. Enjoy modern amenities and a prime location in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge is the perfect choice for families seeking apartments for rent in North Chesterfield VA near James River High School, located just 14.4 km away. Our community offers 1-to-2-bedroom apartment homes, ideal for families, featuring granite countertops, stainless steel appliances, and full-size washer/dryer in every unit. Enjoy a private patio or balcony, perfect for family relaxation. The community amenities include a saltwater pool, a courtyard with a firepit, and a 24-hour fitness center, providing a vibrant and active lifestyle for all ages. Situated within the Stonebridge Shopping Center, Element at Stonebridge offers easy access to downtown Richmond and Richmond’s West End, with convenient transportation options via the GRTC bus line and Chippenham Parkway. Experience family-friendly living with EV charging stations, a covered lounge, and more at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near James River High School",
      "seo_description": "Discover family-friendly apartments for rent in North Chesterfield VA near James River High School at Element at Stonebridge. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-family-friendly-apartments-for-rent-north-chesterfield-va",
      "search_query": "Apartments For Rent In North Chesterfield VA Near A.M. Davis Elementary School",
      "category": "POI",
      "h1_title": "Discover Family-Friendly Apartments For Rent In North Chesterfield VA Near A.M. Davis Elementary School",
      "h2_subtitle": "Element at Stonebridge offers convenient living just 2.8 km from A.M. Davis Elementary School. Enjoy modern amenities and a prime location in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge is the perfect choice for families seeking apartments for rent in North Chesterfield VA near A.M. Davis Elementary School, located just 2.8 km away. Our community offers 1-to-2-bedroom apartment homes, ideal for families, featuring granite countertops, stainless steel appliances, and full-size washer/dryer in every unit. Enjoy a private patio or balcony, perfect for family relaxation. The community amenities include a saltwater pool, a courtyard with a firepit, and a 24-hour fitness center, providing a vibrant and active lifestyle for all ages. Situated within the Stonebridge Shopping Center, Element at Stonebridge offers easy access to downtown Richmond and Richmond’s West End, with convenient transportation options via the GRTC bus line and Chippenham Parkway. Experience family-friendly living with EV charging stations, a covered lounge, and more at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near A.M. Davis Elementary School",
      "seo_description": "Explore family-friendly apartments for rent in North Chesterfield VA near A.M. Davis Elementary School at Element at Stonebridge. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "find-family-friendly-apartments-rent-north-chesterfield-va",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Providence Middle School",
      "category": "POI",
      "h1_title": "Find Family-Friendly Apartments For Rent In North Chesterfield VA Near Providence Middle School",
      "h2_subtitle": "Element at Stonebridge offers convenient living just 3.0 km from Providence Middle School. Enjoy modern amenities and a prime location in North Chesterfield, VA.",
      "page_copy": "Element at Stonebridge is the ideal choice for families seeking apartments for rent in North Chesterfield VA near Providence Middle School, located just 3.0 km away. Our community offers 1-to-2-bedroom apartment homes, perfect for families, featuring granite countertops, stainless steel appliances, and full-size washer/dryer in every unit. Enjoy a private patio or balcony, ideal for family relaxation. The community amenities include a saltwater pool, a courtyard with a firepit, and a 24-hour fitness center, providing a vibrant and active lifestyle for all ages. Situated within the Stonebridge Shopping Center, Element at Stonebridge offers easy access to downtown Richmond and Richmond’s West End, with convenient transportation options via the GRTC bus line and Chippenham Parkway. Experience family-friendly living with EV charging stations, a covered lounge, and more at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near Providence Middle School",
      "seo_description": "Explore family-friendly apartments for rent in North Chesterfield VA near Providence Middle School at Element at Stonebridge. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-apartments-rent-north-chesterfield-va-near-vcu",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Virginia Commonwealth University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In North Chesterfield VA Near Virginia Commonwealth University",
      "h2_subtitle": "Element at Stonebridge offers a vibrant living experience in North Chesterfield, VA. Enjoy spacious 1 to 2 bedroom apartments in a welcoming community.",
      "page_copy": "Element at Stonebridge is your ideal destination for apartments for rent in North Chesterfield VA near Virginia Commonwealth University. Our community features three courtyard-style buildings, providing a serene and comfortable environment for all residents. Each apartment is designed with your lifestyle in mind, offering spacious layouts and modern amenities. \n\nLocated at 301 Karl Linn Drive, Element at Stonebridge is perfectly situated to give you easy access to the best of North Chesterfield and beyond. Whether you're a student at Virginia Commonwealth University or a professional seeking a convenient commute, our apartments offer the perfect blend of comfort and accessibility. Tour today and discover your new home at Element at Stonebridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Apartments For Rent In North Chesterfield VA Near Virginia Commonwealth University",
      "seo_description": "Explore Element at Stonebridge for apartments for rent in North Chesterfield VA near Virginia Commonwealth University. Spacious 1-2 bedrooms available. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-pet-friendly-apartments-for-rent-north-chesterfield-va",
      "search_query": "Pet Friendly Apartments For Rent In North Chesterfield VA",
      "category": "Pet-Friendly",
      "h1_title": "Discover Pet Friendly Apartments For Rent In North Chesterfield VA",
      "h2_subtitle": "Element at Stonebridge offers a welcoming community for you and your pets. Enjoy spacious living in our 1 to 2 bedroom apartments in a serene courtyard setting.",
      "page_copy": "Element at Stonebridge is your ideal destination for pet friendly apartments for rent in North Chesterfield VA. Our community features three courtyard-style buildings, providing a peaceful environment for both you and your furry friends. Each apartment is designed with comfort in mind, offering spacious layouts that cater to your lifestyle needs. Located at 301 Karl Linn Drive, our community is conveniently situated near local amenities, making it easy to enjoy everything North Chesterfield has to offer. Whether you're taking a stroll with your pet or relaxing in your new home, Element at Stonebridge ensures a comfortable and enjoyable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Pet Friendly Apartments For Rent In North Chesterfield VA",
      "seo_description": "Explore Element at Stonebridge for pet friendly apartments for rent in North Chesterfield VA. Spacious 1-2 bedroom homes in a welcoming community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-pet-friendly-apartments-for-rent-near-richmond",
      "search_query": "Pet Friendly Apartments For Rent In North Chesterfield VA Near Richmond",
      "category": "Location",
      "h1_title": "Discover Pet Friendly Apartments For Rent In North Chesterfield VA Near Richmond",
      "h2_subtitle": "Element at Stonebridge offers a welcoming community for you and your furry friends. Enjoy spacious living in a convenient location close to Richmond.",
      "page_copy": "Element at Stonebridge is your ideal destination for pet friendly apartments for rent in North Chesterfield VA near Richmond. Our community features spacious 1 to 2 bedroom apartments nestled in three charming courtyard-style buildings. Located at 301 Karl Linn Drive, our apartments provide a perfect blend of comfort and convenience, making it easy for you and your pets to feel right at home. \n\nWith easy access to Richmond, Element at Stonebridge ensures that you are never far from the vibrant city life while enjoying the tranquility of North Chesterfield. Our pet-friendly policy means your furry companions are always welcome, and our community is designed to cater to both your needs and theirs. Schedule a tour today and see why Element at Stonebridge is the perfect place for you and your pets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Pet Friendly Apartments For Rent In North Chesterfield VA Near Richmond",
      "seo_description": "Explore Element at Stonebridge for pet friendly apartments for rent in North Chesterfield VA near Richmond. Spacious living for you and your pets. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-luxury-apartments-rent-north-chesterfield-va",
      "search_query": "Luxury Apartments For Rent In North Chesterfield VA Near Richmond",
      "category": "Location",
      "h1_title": "Discover Luxury Apartments For Rent In North Chesterfield VA Near Richmond",
      "h2_subtitle": "Element at Stonebridge offers spacious living in a prime location. Experience the comfort and convenience of our 1 to 2 bedroom apartments today.",
      "page_copy": "Element at Stonebridge features luxury apartments for rent in North Chesterfield, VA, near Richmond. Our community is designed to provide residents with a comfortable and convenient lifestyle. Choose from our spacious 1 to 2 bedroom apartments, each thoughtfully designed to meet your needs. Located in three courtyard-style buildings, Element at Stonebridge offers a serene environment with easy access to the vibrant city life of Richmond. Enjoy modern amenities and a welcoming community atmosphere. Schedule a tour today to see why Element at Stonebridge is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Luxury Apartments For Rent In North Chesterfield VA Near Richmond",
      "seo_description": "Explore Element at Stonebridge for luxury apartments for rent in North Chesterfield, VA, near Richmond. Spacious 1-2 bedroom options available. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-two-bedroom-apartments-for-rent-north-chesterfield-va",
      "search_query": "Two Bedroom Apartments For Rent In North Chesterfield VA Near Richmond",
      "category": "Floorplan",
      "h1_title": "Discover Two Bedroom Apartments For Rent In North Chesterfield VA Near Richmond",
      "h2_subtitle": "Element at Stonebridge offers spacious two-bedroom apartments in a vibrant community. Enjoy modern amenities and a convenient location near Richmond.",
      "page_copy": "Element at Stonebridge is your destination for two bedroom apartments for rent in North Chesterfield VA near Richmond. Our community features three courtyard-style buildings, providing a serene and welcoming environment. Each apartment is designed with your comfort in mind, offering spacious layouts and modern finishes. \n\nLocated at 301 Karl Linn Drive, Element at Stonebridge is perfectly situated to provide easy access to the best of North Chesterfield and Richmond. Whether you're commuting for work or exploring local attractions, you'll appreciate the convenience of our location. Schedule a tour today to see why our two-bedroom apartments are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | Two Bedroom Apartments For Rent In North Chesterfield VA Near Richmond",
      "seo_description": "Explore Element at Stonebridge's two bedroom apartments for rent in North Chesterfield VA near Richmond. Spacious layouts and modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-1-bedroom-apartments-for-rent-north-chesterfield-va",
      "search_query": "1 Bedroom Apartments For Rent In North Chesterfield VA",
      "category": "Floorplan",
      "h1_title": "Discover 1 Bedroom Apartments For Rent In North Chesterfield VA",
      "h2_subtitle": "Element at Stonebridge offers spacious living in a vibrant community. Explore our 1 bedroom apartments designed for comfort and convenience.",
      "page_copy": "Element at Stonebridge is your destination for 1 Bedroom Apartments For Rent In North Chesterfield VA. Nestled in a serene setting, our community features three courtyard-style buildings that provide a peaceful retreat from the hustle and bustle of city life. Each 1 bedroom apartment is thoughtfully designed to maximize space and comfort, ensuring you have everything you need to feel at home. \n\nLocated at 301 Karl Linn Drive, Element at Stonebridge is conveniently situated near shopping, dining, and entertainment options, making it easy to enjoy all that North Chesterfield has to offer. Our community is perfect for those seeking a blend of tranquility and accessibility. Schedule a tour today to see why Element at Stonebridge is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | 1 Bedroom Apartments For Rent In North Chesterfield VA",
      "seo_description": "Explore 1 Bedroom Apartments For Rent In North Chesterfield VA at Element at Stonebridge. Spacious living in a vibrant community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5695348706115584",
      "source": "custom",
      "page_item_url": "discover-2-bedroom-apartments-for-rent-north-chesterfield-va",
      "search_query": "2 Bedroom Apartments For Rent In North Chesterfield VA",
      "category": "Floorplan",
      "h1_title": "Discover 2 Bedroom Apartments For Rent In North Chesterfield VA",
      "h2_subtitle": "Element at Stonebridge offers spacious 2 bedroom apartments in a serene courtyard setting. Experience modern living in North Chesterfield, VA, today.",
      "page_copy": "Element at Stonebridge is your destination for 2 Bedroom Apartments For Rent In North Chesterfield VA. Nestled in a tranquil environment, our community features three courtyard-style buildings that provide a peaceful retreat from the hustle and bustle of city life. Each apartment is designed with your comfort in mind, offering ample space and modern amenities to suit your lifestyle. \n\nLocated at 301 Karl Linn Drive, Element at Stonebridge is conveniently situated near local attractions and essential services, making it an ideal choice for those seeking both convenience and comfort. Whether you're looking to relax in your spacious apartment or explore the vibrant community of North Chesterfield, VA, Element at Stonebridge is the perfect place to call home. Schedule a tour today and see why our 2 bedroom apartments are the best choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f6c0e-84d4-7735-b8ea-9c1fed476723",
        "storage_key": "property/5695348706115584/019f6c0e-84d4-7735-b8ea-9c1fed476723.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-8e85-749f-977e-a49483a9e73a",
        "storage_key": "property/5695348706115584/019f6c0e-8e85-749f-977e-a49483a9e73a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Element at Stonebridge | 2 Bedroom Apartments For Rent In North Chesterfield VA",
      "seo_description": "Explore Element at Stonebridge's 2 Bedroom Apartments For Rent In North Chesterfield VA. Spacious living in a serene setting. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2481"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3018954161"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5005818"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KCWCJ2Q"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9282123606"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "3228d0311f11d62a"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwnqk68wd2"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/378fd075-982a-42b4-a1a9-06552bf52c77"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "804-682-2894"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5MTGJKL0pkWXpsOUVjUFB1bUdLL0E9PSIsInZhbHVlIjoiRXFrS0pvWjRzUWxuZkdvR3VISGNOQT09IiwibWFjIjoiNzIwMGU1NDQ5ZWI0NjY0NWQzZGY0YWRkMWFjMmI1YmY5OTgxMzU1ZmQ2ZWVmYzVmMTZkODJlYTExNmE3OGVhMyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2481",
  "custom_repli_id": "3018954161",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5005818",
  "custom_google_gtm_id": "GTM-KCWCJ2Q",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "9282123606",
  "custom_knock_community_id": "3228d0311f11d62a",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwnqk68wd2",
  "custom_self_guided_tour_url": "https://selftournow.com/property/378fd075-982a-42b4-a1a9-06552bf52c77",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "804-682-2894",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5MTGJKL0pkWXpsOUVjUFB1bUdLL0E9PSIsInZhbHVlIjoiRXFrS0pvWjRzUWxuZkdvR3VISGNOQT09IiwibWFjIjoiNzIwMGU1NDQ5ZWI0NjY0NWQzZGY0YWRkMWFjMmI1YmY5OTgxMzU1ZmQ2ZWVmYzVmMTZkODJlYTExNmE3OGVhMyJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:39:32.955Z';
